/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

export interface Review {
  entityType: 'PRODUCT' | 'BRAND' | 'ONBOARDINGPROFILE';
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  entityId: string;
  entityVersion: number;
  /** review comment */
  comment?: string;
  reviewId: string;
  jiraTicketId?: string;
  requestedBy: string;
  /**
   * The date the review was submitted.
   * @format date-time
   */
  reviewStartDate: string;
  /**
   * The date the review was updated.
   * @format date-time
   */
  lastUpdatedDate: string;
  /** Used to track the status of a review */
  status: EntityVersionReviewStatus;
}

export interface ReviewStatusUpdate {
  /** Used to track the status of a review */
  status: EntityVersionReviewStatus;
  /** review comment */
  comment?: string;
  jiraTicketId: string;
}

/** Used to track the status of a review */
export enum EntityVersionReviewStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
}

/** Used to track the certification status of a product */
export enum ProductVersionOverallStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED_UNPUBLISHED = 'APPROVED_UNPUBLISHED',
  APPROVED_PUBLISHED = 'APPROVED_PUBLISHED',
}

/** Used to track the certification status of a brand */
export enum BrandVersionOverallStatus {
  READY = 'READY',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED_UNPUBLISHED = 'APPROVED_UNPUBLISHED',
  APPROVED_PUBLISHED = 'APPROVED_PUBLISHED',
}

/** Used to track the certification status of an onboarding profile */
export enum OnboardingProfileVersionOverallStatus {
  READY = 'READY',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED_UNPUBLISHED = 'APPROVED_UNPUBLISHED',
  APPROVED_PUBLISHED = 'APPROVED_PUBLISHED',
}

/** Entity version statuses */
export enum EntityVersionStatus {
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
  READY = 'READY',
  APPROVED = 'APPROVED',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
}

export type BrandCreate = {
  /**
   * Name of the brand
   * @minLength 1
   * @maxLength 128
   */
  name: string;
  /**
   * Company name of the brand
   * @minLength 0
   * @maxLength 250
   * @example "My company"
   */
  companyName?: string;
  /** Map of localized brand descriptions. The key is the language */
  descriptions?: Record<string, string>;
  /**
   * Site URL of the brand
   * @minLength 0
   * @maxLength 250
   * @example "https://www.example.com"
   */
  siteUrl?: string;
} & BrandContact &
  BrandSupport &
  BrandAddress &
  BrandBillingAddress;

export interface BrandSupport {
  /**
   * Support Information for the brand
   * @minLength 0
   * @maxLength 1000
   */
  supportInformation?: string;
  /**
   * Support email of the brand
   * @minLength 0
   * @maxLength 250
   * @example "myemail@example.com"
   */
  supportEmail?: string;
}

export interface BrandContact {
  /**
   * Contact name of the brand
   * @minLength 0
   * @maxLength 250
   * @example "John Smith"
   */
  contactName?: string;
  /**
   * Contact phone number of the brand
   * @minLength 0
   * @maxLength 100
   * @example "+1-123-567-8907"
   */
  contactPhoneNumber?: string;
  /**
   * Contact email of the brand
   * @minLength 0
   * @maxLength 250
   * @example "myemail@example.com"
   */
  contactEmail?: string;
}

export interface BrandAddress {
  /**
   * Address line 1 of the brand
   * @minLength 0
   * @maxLength 250
   * @example "Road 123"
   */
  addressLine1?: string;
  /**
   * Address line 2 of the brand
   * @minLength 0
   * @maxLength 250
   */
  addressLine2?: string;
  /**
   * City of the brand
   * @minLength 0
   * @maxLength 250
   * @example "Washington"
   */
  city?: string;
  /**
   * State of the brand
   * @minLength 0
   * @maxLength 250
   * @example "AZ"
   */
  state?: string;
  /**
   * Country of the brand
   * @minLength 0
   * @maxLength 250
   * @example "US"
   */
  country?: string;
  /**
   * Zip of the brand
   * @minLength 0
   * @maxLength 50
   * @example 93021
   */
  zip?: string;
}

export interface BrandBillingAddress {
  /**
   * Whether or not this brand uses a billing address
   * @default false
   */
  billingAddress?: boolean;
  /**
   * Address line 1 of the brand billing address
   * @minLength 0
   * @maxLength 250
   * @example "Road 123"
   */
  billingAddressLine1?: string;
  /**
   * Address line 2 of the brand billing address
   * @minLength 0
   * @maxLength 250
   */
  billingAddressLine2?: string;
  /**
   * City of the brand billing address
   * @minLength 0
   * @maxLength 250
   * @example "Washington"
   */
  billingCity?: string;
  /**
   * State of the brand billing address
   * @minLength 0
   * @maxLength 250
   * @example "AZ"
   */
  billingState?: string;
  /**
   * Country of the brand billing address
   * @minLength 0
   * @maxLength 250
   * @example "US"
   */
  billingCountry?: string;
  /**
   * Zip of the brand billing address
   * @minLength 0
   * @maxLength 50
   * @example 93021
   */
  billingZip?: string;
}

export type BrandUpdate = BrandCreate;

export type BrandMigration = BrandCreate & {
  /**
   * Organization Id to migrate the brand to
   * @format uuid
   */
  organizationId?: string;
  /**
   * Warehouse Id of the brand to migrate
   * @format uuid
   */
  warehouseBrandId: string;
};

export interface BrandVersionResponse {
  /**
   * Brand Id
   * @format uuid
   */
  brandId: string;
  /**
   * The version of a brand
   * @example 1
   */
  versionNumber: number;
  /** Entity version statuses */
  versionStatus: EntityVersionStatus;
  /** Used to track the certification status of a brand */
  overallStatus?: BrandVersionOverallStatus;
  /**
   * The date when the Brand was created
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateCreated?: string;
  /**
   * The date when the new version of the Brand was created
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateVersionCreated?: string;
  /**
   * The date when the Brand was last updated
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateUpdated?: string;
}

export type Brand = BrandCreate &
  BrandVersionResponse & {
    /** Icon url */
    icon?: string;
    /**
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "81bfb21a-8716-410b-b2c7-40c14f585b60"
     */
    warehouseBrandId?: string;
  };

export interface ProductVersionUpdate {
  /**
   * name of the product
   * @minLength 1
   * @maxLength 250
   */
  productName: string;
  /**
   * model number of the product
   * @minLength 1
   * @maxLength 250
   */
  modelNumber: string;
  /**
   * id of the category of the product as available in response from GET /productcategories
   * @format uuid
   */
  productCategoryId?: string;
  /** ids of the categories of the product as available in response from GET /productcategories */
  productCategoryIds?: string[];
  /**
   * Id of the device profile
   * @format uuid
   */
  deviceProfileId?: string;
  /** region this product is available in */
  distributionRegion?: DistributionRegion;
  /** 2 letter codes of countries in the region the product is available in */
  countries: string[];
  testingInfo?: TestingInfo;
  contactInfo?: ContactInfo;
  comments?: string;
  /**
   * SmartThings Schema Connector ID
   * @format uuid
   */
  connectorId?: string;
  /**
   * Id of the Brand this product belongs to
   * @format uuid
   */
  brandId?: string;
  /** Protocol the device uses. Will be null for cloud devices */
  protocol?: Protocol;
  /**
   * id of the driver the product uses
   * @format uuid
   */
  driverId?: string;
  /**
   * id of the onboarding profile the product uses
   * @format uuid
   */
  onboardingProfileId?: string;
  /**
   * URL from the Pull Request with the code changes
   * @minLength 0
   * @maxLength 500
   */
  githubUrl?: string;
  /** List of the product capabilities */
  capabilities?: string[];
  /** The identifier for the respective fingerprint, unique per driver */
  fingerprintId?: FingerprintId;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * The date when the Product was created
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateCreated?: string;
  /**
   * The date when the new version of the Product was created
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateVersionCreated?: string;
  /**
   * The date when the Product was last updated
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateUpdated?: string;
  /**
   * The purchase URL of the product
   * @minLength 0
   * @maxLength 500
   */
  purchaseUrl?: string;
  /** Vendor Id of the device */
  vid?: MatterVendorId;
  /** Product Id of the device */
  pid?: MatterProductId;
  fingerprint?: Fingerprint;
  /** Voice Assistants the product is compatible with */
  voiceCompatibility?: VoiceAssistant[];
}

export type InternalBrandUpdate = BrandContact & BrandSupport;

export type ProductCreate = ProductVersionUpdate & {
  /** How the product connects to SmartThings */
  type: ProductType;
};

export type ProductVersion = ProductCreate & {
  /**
   * Product Id
   * @format uuid
   */
  productId: string;
  /** versionNumber */
  versionNumber?: number;
  /** Product image url */
  image?: string;
  /** Entity version statuses */
  versionStatus?: EntityVersionStatus;
  /** Used to track the certification status of a product */
  overallStatus?: ProductVersionOverallStatus;
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "81bfb21a-8716-410b-b2c7-40c14f585b60"
   */
  warehouseProductId?: string;
};

export interface ProductMigration {
  /**
   * Warehouse Id of the product to migrate
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  warehouseProductId: string;
  /** Protocol the device uses. Will be null for cloud devices */
  protocol?: Protocol;
  /**
   * @minLength 0
   * @maxLength 250
   */
  hardwareVersion?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  firmwareVersion?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  powerSource?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  socket?: string;
  accessories?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  productUrl?: string;
  /**
   * if manufactured by 3rd party
   * @minLength 0
   * @maxLength 250
   */
  manufacturer?: string;
  factoryResetInstructions?: string;
  githubUrl?: string;
  purchaseUrl?: string;
}

/** How the product connects to SmartThings */
export enum ProductType {
  HUB = 'HUB',
  CLOUD = 'CLOUD',
}

/** Protocol the device uses. Will be null for cloud devices */
export enum Protocol {
  ZIGBEE_HA = 'ZIGBEE_HA',
  ZIGBEE30 = 'ZIGBEE_30',
  ZIGBEE_LL = 'ZIGBEE_LL',
  ZWAVE = 'ZWAVE',
  ZWAVES2 = 'ZWAVE_S2',
  LAN = 'LAN',
  MATTER_THREAD = 'MATTER_THREAD',
  MATTER_WIFI = 'MATTER_WIFI',
}

export enum VoiceAssistant {
  ALEXA = 'ALEXA',
  BIXBY = 'BIXBY',
  GOOGLE_ASSISTANT = 'GOOGLE_ASSISTANT',
}

/** region this product is available in */
export enum DistributionRegion {
  GLOBAL = 'GLOBAL',
  NA = 'NA',
  AMERS = 'AMERS',
  EU = 'EU',
  EMEA = 'EMEA',
  AP = 'AP',
  APAC = 'APAC',
  ZWaveNA = 'Z-Wave_NA',
  ZWaveEU = 'Z-Wave_EU',
  ZWaveANZ = 'Z-Wave_ANZ',
  ZWaveKOR = 'Z-Wave_KOR',
}

export interface TestingInfo {
  /**
   * @minLength 0
   * @maxLength 250
   */
  hardwareVersion?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  firmwareVersion?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  powerSource?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  socket?: string;
  accessories?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  productDimensions?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  productUrl?: string;
  /**
   * if manufactured by 3rd party
   * @minLength 0
   * @maxLength 250
   */
  manufacturer?: string;
  factoryResetInstructions?: string;
  additionalInfo?: string;
  warnings?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  testCredentialsUsername?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  testCredentialsPassword?: string;
}

export interface OnboardingProfile {
  /** @format uuid */
  onboardingProfileId: string;
  onboardingProfileType: OnboardingProfileType;
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
  /** versionNumber */
  versionNumber: number;
  /** Entity version statuses */
  versionStatus: EntityVersionStatus;
  /** Used to track the certification status of an onboarding profile */
  overallStatus?: OnboardingProfileVersionOverallStatus;
  /** @example {"EDGE":"81bfb21a-8716-410b-b2c7-40c14f585b60","MATTER":"ab087a65-379f-4f63-9867-9de28f6b314b"} */
  warehouseAppIds?: {
    type?: OnboardingProfileAppType;
    [key: string]: any;
  };
  /**
   * The date when the Onboarding Profile was created
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateCreated?: string;
  /**
   * The date when the new version of the Onboarding Profile was created
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateVersionCreated?: string;
  /**
   * The date when the Onboarding Profile was last updated
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  dateUpdated?: string;
  /** @format uuid */
  onboardingProfileVersionId?: string;
}

export enum OnboardingProfileType {
  EDGE = 'EDGE',
}

export enum OnboardingProfileAppType {
  EDGE = 'EDGE',
  MATTER = 'MATTER',
}

export type OnboardingProfileEdge = OnboardingProfile & {
  /** Map of localized data. The key is the language */
  localizations: Record<string, OnboardingProfileEdgeLocalization>;
};

export interface OnboardingProfileEdgeLocalization {
  pairingSteps: OnboardingProfileEdgePairingStep;
  troubleShootingInstructions: string;
  disconnectionSteps?: string;
  /**
   * @minLength 1
   * @maxLength 250
   */
  displayName: string;
}

export interface OnboardingProfileEdgePairingStep {
  prepare: string;
}

export interface OnboardingProfileCreate {
  onboardingProfileType: OnboardingProfileType;
  name: string;
}

export interface OnboardingProfileUpdate {
  onboardingProfileType: OnboardingProfileType;
  name: string;
}

export type OnboardingProfileEdgeCreate = OnboardingProfileCreate & {
  /** Map of localized data. The key is the language */
  localizations: Record<string, OnboardingProfileEdgeLocalization>;
};

export type OnboardingProfileEdgeUpdate = OnboardingProfileUpdate & {
  /** Map of localized data. The key is the language */
  localizations: Record<string, OnboardingProfileEdgeLocalization>;
};

export interface ContactInfo {
  /**
   * @minLength 0
   * @maxLength 250
   */
  contactName?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  phoneNumber?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  emailAddress?: string;
}

export interface TosData {
  agreed: boolean;
  tosName: string;
  tosVersion: number;
  /**
   * will be null if tos is not accepted
   * @format date-time
   */
  agreementDate?: string;
}

/**
 * The identifier for the respective fingerprint, unique per driver
 * @format ^[a-zA-Z0-9 _/\\\-()\\[\\]{}\.]{1,36}$
 * @example "smartthings.motion-v4"
 */
export type FingerprintId = string;

/**
 * Label assigned to device at join time. If this is not set the driver name is used.
 * @format ^[a-zA-Z0-9 _\/\\-()\[\]{}\.]{1,50}$
 * @example "Motion Sensor"
 */
export type FingerprintDeviceLabel = string;

export interface DeviceIntegrationProfileKey {
  /**
   * Unique identifier for integration profile.
   * @format uuid
   */
  id: string;
  /**
   * Major Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  majorVersion: number;
  /**
   * Minor Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  minorVersion?: number;
  /**
   * @format uuid
   * @example "a362ddb6-349b-4650-9911-681b51069a57"
   */
  overrideProfileId?: string;
}

export interface MatterManufacturerInfo {
  /** Vendor Id of the device */
  vendorId?: MatterVendorId;
  /** Product Id of the device */
  productId?: MatterProductId;
}

export interface Clusters {
  /** List of 16-bit cluster identifiers for client clusters */
  client?: ClientClusters;
  /** List of 16-bit cluster identifiers for server clusters */
  server?: ServerClusters;
}

export interface CommandClasses {
  /** List of 8-bit command class identifiers to match regardless of controlled or supported */
  either?: number[];
  /** List of 8-bit command class identifiers that are controlled */
  controlled?: number[];
  /** List of 8-bit command class identifiers that are supported */
  supported?: number[];
}

/** List of 16-bit cluster identifiers for client clusters */
export type ClientClusters = number[];

/** List of 16-bit cluster identifiers for server clusters */
export type ServerClusters = number[];

/**
 * Device Identifiers associated with a generic zigbee fingerprint
 * @example [257]
 */
export type DeviceIdentifiers = number[];

/**
 * Vendor Id of the device
 * @min 0
 * @max 65535
 */
export type MatterVendorId = number;

/**
 * Product Id of the device
 * @min 0
 * @max 65535
 */
export type MatterProductId = number;

export interface MatterFingerprintDeviceType {
  /**
   * @min 0
   * @max 4294967295
   */
  deviceTypeId?: number;
}

/**
 * Reported manufacturer of the device
 * @minLength 0
 * @maxLength 32
 * @example "SmartThings"
 */
export type ZigbeeManufacturer = string;

/**
 * Reported model of the device
 * @minLength 0
 * @maxLength 32
 * @example "motionv4"
 */
export type ZigbeeModel = string;

/**
 * Device profiles associated with a generic zigbee fingerprint
 * @example [260]
 */
export type ZigbeeProfiles = number[];

/**
 * 8-bit indicator for the generic type of the device
 * @min 0
 * @max 255
 * @example 6
 */
export type ZWaveGenericType = number;

/**
 * 8-bit indicator for the specific type of the device
 * @min 0
 * @max 255
 * @example 6
 */
export type ZWaveSpecificType = number;

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

export interface TicketReference {
  key: string;
}

export type BrandTicketReference = TicketReference & {
  entity: Brand;
};

export type OnboardingProfileTicketReference = TicketReference & {
  entity: OnboardingProfileEdge;
};

export interface TicketCreate {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  reviewId: string;
}

export interface TicketCreated {
  /** Key of the ticket created by jira */
  key: string;
  /**
   * Ticket Creation date
   * @format date-time
   */
  createdDate: string;
  /** Jira status of the ticket after creation */
  status: string;
}

export type BrandTicketCreate = TicketCreate & {
  brand: Brand;
};

export type OnboardingProfileTicketCreate = TicketCreate & {
  onboardingprofile: OnboardingProfileEdge;
};

export type JiraProductVersion = ProductVersion & {
  categoryNames: string[];
  driverName: string;
};

export type ProductTicketCreate = TicketCreate & {
  product: JiraProductVersion;
  /** Product brand */
  brand: BrandTicketReference;
  /** Product onboarding profile */
  onboardingprofile?: OnboardingProfileTicketReference;
};

export interface Fingerprint {
  /** Type of fingerprint */
  type: FingerprintType;
  /** The identifier for the respective fingerprint, unique per driver */
  id: FingerprintId;
  /** The name of the device profile that the device should use */
  deviceProfileName?: string;
  /** Label assigned to device at join time. If this is not set the driver name is used. */
  deviceLabel?: FingerprintDeviceLabel;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
}

export type MatterManufacturerFingerprint = Fingerprint & MatterManufacturerInfo;

export type MatterGenericFingerprint = Fingerprint & {
  deviceTypes?: MatterFingerprintDeviceType[];
};

export type ZigbeeManufacturerFingerprint = Fingerprint & {
  /** Reported manufacturer of the device */
  manufacturer?: ZigbeeManufacturer;
  /** Reported model of the device */
  model?: ZigbeeModel;
};

export type ZigbeeGenericFingerprint = Fingerprint & {
  clusters?: Clusters;
  /** Device Identifiers associated with a generic zigbee fingerprint */
  deviceIdentifiers?: DeviceIdentifiers;
  /** Device profiles associated with a generic zigbee fingerprint */
  zigbeeProfiles?: ZigbeeProfiles;
};

export type ZWaveManufacturerFingerprint = Fingerprint & {
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
};

export type ZWaveGenericFingerprint = Fingerprint & {
  /** 8-bit indicator for the generic type of the device */
  genericType?: ZWaveGenericType;
  /** List of reported command classes */
  specificType?: ZWaveSpecificType[];
  /** List of CommandClasses to match on */
  commandClasses?: CommandClasses;
};

/** Type of fingerprint */
export enum FingerprintType {
  MATTER_MANUFACTURER = 'MATTER_MANUFACTURER',
  MATTER_GENERIC = 'MATTER_GENERIC',
  ZIGBEE_MANUFACTURER = 'ZIGBEE_MANUFACTURER',
  ZIGBEE_GENERIC = 'ZIGBEE_GENERIC',
  ZWAVE_MANUFACTURER = 'ZWAVE_MANUFACTURER',
  ZWAVE_GENERIC = 'ZWAVE_GENERIC',
}

export interface PagedAnalyticsData {
  items?: Measure[];
  links?: Links;
}

export interface Measure {
  type: MeasureType;
  /**
   * The name of the measure
   * @example "active_devices"
   */
  measureName: string;
  dimensions: Dimension[];
}

export enum MeasureType {
  NUMBER = 'NUMBER',
  INTEGER = 'INTEGER',
}

export type MeasureNumber = Measure & {
  values: MeasureNumberValue[];
};

export interface MeasureNumberValue {
  /**
   * The timestamp for the value
   * @format date-time
   * @example 1667245928
   */
  timestamp: string;
  /**
   * The number value
   * @example 10687
   */
  value: number;
}

export type MeasureInteger = Measure & {
  values: MeasureIntegerValue[];
};

export interface MeasureIntegerValue {
  /**
   * The timestamp for the value
   * @format date-time
   * @example 1667245928
   */
  timestamp: string;
  /**
   * The integer value
   * @example 10687
   */
  value: number;
}

export interface Dimension {
  /**
   * The name of the dimension
   * @example "productId"
   */
  dimensionName: string;
  /**
   * The value of the dimension
   * @example "858f6e93-4ed0-41b6-a962-28d50f737825"
   */
  value: string;
}

/** A typed model which describes a restriction pertaining to a platform entity. */
export interface Restriction {
  /** The restriction level of an entity to limit actions it can take. */
  tier: number;
  /** The number of days to retain the state before deletion. */
  historyRetentionTTLDays?: number;
  /**
   * Indicate whether or not the entity is visible when restricted.
   * @default false
   */
  visibleWhenRestricted?: boolean;
}

/**
 * A typed model which provides information around ownership of a specific domain.
 * @example {"ownerType":"USER","ownerId":"72fd3b54-d243-4bf7-a845-92eb7956b982"}
 */
export interface Owner {
  /**
   * The type of owner that owns this entity. "Account" refers specifically to a coterie account ID.
   * @default "USER"
   */
  ownerType: 'USER' | 'SYSTEM' | 'IMPLICIT' | 'ACCOUNT';
  /** A global identifier for owner. */
  ownerId: string;
}

export interface OcfDeviceProfiles {
  items?: OcfDeviceProfile[];
}

/** @example {"commands":[{"component":"main","capability":"colorTemperature","command":"setColorTemperature","arguments":["30000"]}]} */
export interface DeviceCommandsRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceCommand[];
}

/** @example {"component":"main","capability":"switchLevel","command":"setLevel","arguments":[80]} */
export interface DeviceCommand {
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @default "main"
   */
  component?: string;
  /** Capability that this command relates to. This must be a capability of the component. */
  capability: string;
  /** Name of the command, this must be valid for the capability. */
  command: string;
  /**
   * Arguments of the command.
   * All the required arguments defined in the capability's command argument definition must be provided.
   * The type of the arguments are dependent on the type of the capability's command argument.
   * Please refer to the capabilities definition at https://developer-preview.smartthings.com/docs/devices/capabilities/capabilities-reference
   */
  arguments?: object[];
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

export interface BatchDeviceCommandsRequest {
  /** An array of commands to execute on the specified Device. */
  commands?: BatchDeviceCommand[];
}

export type BatchDeviceCommand = {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
} & DeviceCommand;

export interface DeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceStateEvent[];
}

export interface IdLessHealthState {
  /** Current state of the device */
  state?: 'ONLINE' | 'OFFLINE';
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/** A paginated array of Devices. */
export interface PagedDevices {
  items?: Device[];
  _links?: Links;
}

export interface Device {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "color.light.100x"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device manufacturer name.
   * @example "SmartThings"
   */
  manufacturerName: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * An non-unique id that is used to help drive UI information.
   * @example "VD-STV_2018_K"
   */
  presentationId: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** The IDs of all locations this device is shared with. */
  sharedLocations?: SharedLocation[];
  /** The IDs of all compenents on the device. */
  components?: DeviceComponent[];
  /** The time when the device was created at. */
  createTime?: string;
  healthState?: IdLessHealthState;
  /** The id of the Parent device. */
  parentDeviceId?: string;
  /** Device details for all child devices of the device. */
  childDevices?: ChildDeviceRef[];
  profile?: DeviceProfileReference;
  /** Device Profile information for a SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
  app?: AppDeviceDetails;
  /** Bluetooth device information. This field will be empty if device type is not BLE. */
  ble?: BleDeviceDetails;
  /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
  bleD2D?: BleD2DDeviceDetails;
  /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
  dth?: DthDeviceDetails;
  /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
  lan?: LanDeviceDetails;
  /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
  zigbee?: ZigbeeDeviceDetails;
  /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
  zwave?: ZwaveDeviceDetails;
  /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
  matter?: MatterDeviceDetails;
  /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
  edgeChild?: EdgeChildDeviceDetails;
  /** HUB device information. This field will be empty if the device type is not HUB. */
  hub?: HubDeviceDetails;
  /** MOBILE device information. This field will be empty if the device type is not MOBILE. */
  mobile?: MobileDeviceDetails;
  /** IR device information. This field will be empty if device type is not IR. */
  ir?: IrDeviceDetails;
  /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
  irOcf?: IrDeviceDetails;
  /** OCF device information. This field will be empty if device type is not OCF. */
  ocf?: OcfDeviceDetails;
  /** Viper device information. This field will be empty if device type is not VIPER. */
  viper?: ViperDeviceDetails;
  /** Group device information. This field will be empty if device type is not GROUP. */
  group?: GroupDeviceDetails;
  /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
  virtual?: VirtualDeviceDetails;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * *DEPRECATED* please use `presentationId`
   * Vendor id of the device, used for UI.
   */
  vid?: string;
  /**
   * *DEPRECATED* please use `manufacturerName`
   * Manufacturer model number, used for UI.
   */
  mnmn?: string;
  /** The OCF device type (resource), used for UI. */
  ocfDeviceType?: string;
  /** Restriction tier of the device, if any. */
  restrictionTier: number;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:devices - the user can change device details
   *   <li> w:devices:locationId - the user can move the device from a location
   *   <li> w:devices:roomId - the user can move or remove the device from a room
   *   <li> x:devices - the user can execute commands on the device
   *   <li> d:devices - the user can uninstall the device
   *   </ul>
   * @uniqueItems true
   */
  allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/**
 * The type of device integration.
 * All types besides ENDPOINT_APP will have profile populated.
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is VIPER, the details are in the "viper" field.
 */
export enum DeviceIntegrationType {
  APP = 'APP',
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/** object to query device components status */
export interface DeviceStatusQuery {
  components?: Record<string, ComponentStatusQuery>;
  healthState?: any;
}

/** object to query component capabilities status */
export interface ComponentStatusQuery {
  capabilities?: Record<string, CapabilityStatusQuery>;
}

/** object to query capability attributes status */
export interface CapabilityStatusQuery {
  attributes?: string[];
}

export interface IrDeviceDetails {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCode?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDeviceDetails[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

export interface OcfDeviceDetails {
  /** OCF device type */
  ocfDeviceType?: string;
  /** Name of the device */
  name?: string;
  /** OCF spec version */
  specVersion?: string;
  /** OCF vertical domain spec version */
  verticalDomainSpecVersion?: string;
  /** OCF manufacturer name */
  manufacturerName?: string;
  /** OCF model number */
  modelNumber?: string;
  /** OCF platform version */
  platformVersion?: string;
  /** OCF platform OS */
  platformOS?: string;
  /** OCF platform H/W version */
  hwVersion?: string;
  /** OCF firmware version */
  firmwareVersion?: string;
  /** OCF vendor ID */
  vendorId?: string;
  /** OCF vendor resource client/server version */
  vendorResourceClientServerVersion?: string;
  /** Language code */
  locale?: string;
  /** The time when the device is signed up lastly */
  lastSignupTime?: string;
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
export interface MatterDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** Vendor-supplied unique identifier. Optional. */
  uniqueId?: string;
  /** 16-bit vendor id. Optional. */
  vendorId?: number;
  /** 16-bit product id. Optional. */
  productId?: number;
  /** Listening type for the device. Optional. */
  listeningType?: MatterListeningType;
  /** List of network interfaces. Optional. */
  supportedNetworkInterfaces?: MatterNetworkInterfaces;
  /** Hardware and Software version info for matter devices. Optional. */
  version?: MatterVersion;
  /** Available Matter endpoints */
  endpoints?: MatterEndpoints;
  /** Determines whether or not to sync the child device's driver from its parent. Default is true. */
  syncDrivers?: SyncDrivers;
}

/** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
export interface EdgeChildDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The identifier assigned to this edge child device by its parent */
  parentAssignedChildKey?: ParentAssignedChildKey;
}

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The identifier for the Device instance.
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type DeviceId = string;

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/** Available Matter endpoints */
export type MatterEndpoints = MatterEndpoint[];

/** Matter device endpoint */
export interface MatterEndpoint {
  /**
   * 16-bit identifier for the endpoint
   * @min 0
   * @max 65535
   * @example 771
   */
  endpointId?: number;
  /** List of device types for the endpoint */
  deviceTypes?: MatterEndpointDeviceType[];
}

/** Device type for a matter endpoint */
export interface MatterEndpointDeviceType {
  /**
   * 32-bit identifier for the device type
   * @min 0
   * @max 4294967295
   * @example 197379
   */
  deviceTypeId?: number;
}

/**
 * Determines whether or not to sync the child device's driver from its parent. Default is true.
 * @example true
 */
export type SyncDrivers = boolean;

/** The identifier assigned to this edge child device by its parent */
export type ParentAssignedChildKey = string;

/**
 * The hub that the device is connected to.
 * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
 */
export type HubId = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

/** MOBILE device information. This field will be empty if the device type is not MOBILE. */
export type MobileDeviceDetails = object;

export interface HubDriver {
  /** The version of the driver revision being returned */
  driverVersion?: string;
  /**
   * The identifier of the Sprocket driver
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  driverId: string;
  /**
   * The identifier of the Sprocket channel
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  channelId?: string;
}

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/**
 * Describes state of Zigbee OTA.
 * @default "DISABLED"
 */
export enum ZigbeeOta {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ENABLED_WITH_LIGHTS = 'ENABLED_WITH_LIGHTS',
}

export interface ChildDeviceRef {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  id?: string;
}

export interface SharedLocation {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  locationId?: string;
}

export interface ViperDeviceDetails {
  /** @example "1a-74" */
  uniqueIdentifier?: string;
  /** @example "TP-Link" */
  manufacturerName?: string;
  /** @example "HS101" */
  modelName?: string;
  /** @example "23.123.231" */
  swVersion?: string;
  /** @example "v1 US bulb" */
  hwVersion?: string;
  /** @example "viper_bb238c20-675a-11ed-970f-571777eb58c5" */
  endpointAppId?: string;
}

/** An array of devices in the group */
export interface DeviceGroupDevice {
  /**
   * GUID representing the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
   */
  deviceId: string;
  /** Components to add to the group */
  components?: {
    /** @example "main" */
    id?: string;
    [key: string]: any;
  }[];
}

export interface VirtualDeviceDetails {
  /** Name of the device */
  name?: string;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  commandMappings?: CommandMappings;
}

export interface CommandMappings {
  commands?: CommandMapping[];
}

/**
 * A mapping of `commandName` to `attribute.value` that will allow users to support complex commands that would otherwise
 * not be determinable simply by the capabililty contract.
 */
export interface CommandMapping {
  /** The Capability ID. */
  capabilityId: string;
  /** The Capability version number. */
  version: number;
  /** The command name to apply the mapping to on the device */
  command: string;
  /** A collection of attribute values, replicator will use these to create device events in serial for the specified command. */
  eventValues: AttributeValue[];
}

/** The description of an attribute value that will be used to populate an event. */
export interface AttributeValue {
  /** The attribute that this command will correspond to */
  attribute?: string;
  /** How will the attribute be provided? Choose either to provide it with a command at runtime or to provide a set value here. */
  inputType?: 'STATIC' | 'ARGUMENT';
  /** The argument to be used automatically for this command mapping. Any simple type is accepted. */
  staticValue?: object;
}

export interface PagedDeviceComponents {
  items?: DeviceComponent[];
  _links?: Links;
}

export interface UpdateDeviceComponent {
  /** @example "main" */
  id: string;
  /**
   * The label for the device component.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light switch 2"
   */
  label?: string;
  /**
   * Identifier allowing the user to pick a custom icon for the device component.
   * The icon of the main component represents the device itself
   * @minLength 1
   * @maxLength 255
   */
  icon?: string;
  /**
   * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). Allows the user to redefine the category of the device from what the manufacturer set by default.
   * @maxItems 1
   * @minItems 1
   */
  categories: string[];
}

/** @example {"label":"Living room light","locationId":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","roomId":"0fd2b1ef-1b33-4a54-9153-65aca91e9660","components":[{"id":"main","label":"living room light switch 2","icon":"string","categories":["Light"]}],"indoorMap":{"coordinates":[1,2,3],"rotation":[0,0,0],"visible":true}} */
export interface UpdateDeviceRequest {
  /**
   * The label for the Device.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /**
   * The ID of the Location where the Device should be moved to.
   * Not all Devices support Location moves.
   * Moving between some Locations may be rejected depending on the data region used.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which to associate the Device is associated.
   * The Room must be valid for the Location of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  components?: UpdateDeviceComponent[];
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/** HUB device information. This field will be empty if the device type is not HUB. */
export interface HubDeviceDetails {
  /**
   * The unique identifier for this manufactured hub.
   * @format ^[0-9A-F]{16}$
   * @example "D053A8B4F6D80001"
   */
  hubEui: string;
  /**
   * The hub's firmware version
   * @format ^[0-9]\.[0-9]\.[0-9]{3}$
   * @example ""
   */
  firmwareVersion: string;
  /** A list of drivers installed on the hub */
  hubDrivers: HubDriver[];
  hubData: {
    /**
     * Zwave static DSK for the hub.
     * @example "21720-31296-41384-03009-58023-25366-38831-43982"
     */
    zwaveStaticDsk?: string;
    /** Whether zwaveS2 is enabled for this hub. */
    zwaveS2: boolean;
    /**
     * The hardwareType for this hub
     * @example "V3_HUB"
     */
    hardwareType: string;
    /**
     * The hub's hardware ID
     * @example "00A2"
     */
    hardwareId?: string;
    /**
     * The Zigbee firmware version for this hub
     * @example "5.4.0"
     */
    zigbeeFirmware?: string;
    /** Whether the hub supports zigbee3 */
    zigbee3: boolean;
    /** Describes state of Zigbee OTA. */
    zigbeeOta?: ZigbeeOta;
    /** Indicates if Zigbee OTA is enabled. */
    otaEnable?: string;
    /** Whether the hub allows zigbee unsecure rejoin */
    zigbeeUnsecureRejoin: boolean;
    /** Possible Values for Hub Characteristic "Availability" flags */
    primarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    secondarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zigbeeAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zwaveAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    threadAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    lanAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    matterAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    localVirtualDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    childDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    edgeDriversAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    hubReplaceAvailability?: AvailabilityCharacteristic;
    /** The primary hub device id for this hub. Null/Empty if hub is not a repeater. */
    primaryHubDeviceId?: string;
    /** The Zigbee Channel of the Hub. */
    zigbeeChannel?: string;
    /** The Personal Area Network (PAN) id of the zigbee network the hub is on. */
    zigbeePanId?: string;
    /** The unique identifier for this manufactured hub. */
    zigbeeEui?: string;
    /** The short address of a node in Zigbee network. */
    zigbeeNodeID?: string;
    /** The address of a single node in the network */
    zwaveNodeID?: string;
    /** The common identification of all nodes belonging to one logical Z-Wave network */
    zwaveHomeID?: string;
    zwaveSucID?: string;
    zwaveVersion?: string;
    /** The global region this zwave radio is operating in. */
    zwaveRegion?: string;
    /** MAC address of the hubs network interface. */
    macAddress?: string;
    /** IP address of the hub. */
    localIP?: string;
    /** Whether the hub is zigbee radio functional. */
    zigbeeRadioFunctional?: boolean;
    /** Whether the hub is zwave radio functional. */
    zwaveRadioFunctional?: boolean;
  };
}

export interface DeviceComponent {
  /** UTF-8 label for the component. */
  label?: string;
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /**
   * A list of `[ 1..20 ]` capabilities for this component.
   * @maxItems 20
   * @minItems 1
   */
  capabilities: CapabilityReference[];
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
}

export interface CapabilityConfiguration {
  values: CapabilityConfigurationValue[];
}

export interface CapabilityConfigurationValue {
  /**
   * The path to the preference attribute that is being configured.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * The range of values supported by the capability attribute. The range must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @maxItems 2
   * @minItems 2
   * @example "[1, 50]"
   */
  range?: number[];
  /**
   * The list of enumerated values that are supported for the capability attribute. The list of supported value must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @example "[ "cooling", "fan only", "heating", "idle" ]"
   */
  enabledValues?: string[];
  /**
   * The incremental step that increases or decreases for numeric values.
   * @format double
   * @default 1
   */
  step?: number;
}

export interface BaseCapabilityReference {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

export type CapabilityReferenceRequest = BaseCapabilityReference & {
  config?: CapabilityConfiguration;
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
};

export type CapabilityReference = CapabilityReferenceRequest & {
  /** @example false */
  ephemeral?: boolean;
};

export type DeviceCapabilityReference = CapabilityReference & {
  /** A map of Attribute name to Attribute state. */
  status?: CapabilityStatus;
};

/** The status of a Device. */
export interface DeviceStatus {
  /**
   * A map of componentId to Component status.
   * @example {"main":{"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}}
   */
  components?: Record<string, ComponentStatus>;
  healthState?: {
    /** Current state of the device */
    state?: 'ONLINE' | 'OFFLINE';
    /**
     * Last reported date/time in UTC
     * @format date-time
     */
    lastUpdatedDate?: string;
  };
}

/**
 * A map of capabilityId to Capability status.
 * @example {"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}
 */
export type ComponentStatus = Record<string, CapabilityStatus>;

/**
 * A map of Attribute name to Attribute state.
 * @example {"switch":{"value":"on"}}
 */
export type CapabilityStatus = Record<string, AttributeState>;

export interface AttributeState {
  /** @example 0 */
  value?: object;
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

/** @example {"component":"main","capability":"switchLevel","attribute":"level","value":0,"unit":null,"data":null} */
export interface DeviceStateEvent {
  /** The name of the component on this device, default is 'main'. */
  component?: string;
  /** Capability that this event relates to. */
  capability?: string;
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Value associated with the event. The valid value depends on the capability. */
  value: object;
  /** Unit of the value field. */
  unit?: string;
  /** Key value pairs about the state of the device. Valid values depend on the capability. */
  data?: Record<string, object>;
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

export interface CreateBackendEventsResponse {
  /** The list of state changes for each event created in the order in the create request */
  stateChanges?: boolean[];
}

export type CreateDeviceEventsResponse = object;

export interface DeviceCommandsResponse {
  results?: CommandResult[];
}

export interface CommandResult {
  /**
   * A UUID used for tracking the individual command.
   * @format uuid
   */
  id?: string;
  /**
   * `ACCEPTED`: the command is processing but it's outcome is unknown
   * `COMPLETED`: the command has successfully completed
   * `FAILED`: the command has failed
   */
  status?: CommandStatus;
}

/**
 * `ACCEPTED`: the command is processing but it's outcome is unknown
 * `COMPLETED`: the command has successfully completed
 * `FAILED`: the command has failed
 */
export enum CommandStatus {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type CreateBatchDeviceCommandsResponse = object;

export interface BackendInstallRequest {
  /**
   * The id that should be used for the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  deviceId?: string;
  /**
   * The owner id of the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  ownerId?: string;
  /**
   * The name that the device integration defines for the device.
   * @minLength 1
   * @maxLength 255
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The display label for the device.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @maxLength 255
   */
  label?: string;
  /** The location id that the device will be installed on. */
  locationId: string;
  /**
   * The id of the parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /** The device profile id that describes the components and capabilities. */
  profileId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * The device manufacturer code.
   * @maxLength 255
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @maxLength 255
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * Room containing this device
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  roomId?: string;
  components?: {
    /** @example "main" */
    id: string;
    /** @example "main" */
    label?: string;
    /**
     * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories).
     * @maxItems 1
     * @minItems 1
     */
    categories: string[];
  }[];
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs stored in the conductor for the device.
   * These are returned with requests to the backend.
   */
  metadata?: Record<string, object>;
  /** A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header */
  secret?: string;
  /** Optional - the definition of the device profile that this device should use. */
  deviceProfileOverride?: DeviceProfile;
}

export interface BackendUpdateRequest {
  /**
   * The owner id of the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  ownerId?: string;
  /** The device profile id that describes the components and capabilities. */
  profileId?: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * The device manufacturer code.
   * @minLength 1
   * @maxLength 255
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @maxLength 255
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * The name that the device integration defines for the device.
   * @minLength 1
   * @maxLength 255
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @minLength 0
   * @maxLength 255
   * @example "My light"
   */
  label?: string;
  components?: {
    /** @example "main" */
    id: string;
    /** @example "main" */
    label?: string;
  }[];
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type?: DeviceIntegrationType;
  /** The parent to associate the device with. This is primarily for migration of devices. */
  parentDeviceId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs stored in the conductor for the device.
   * These are returned with requests to the backend.
   */
  metadata?: Record<string, any>;
  /** A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header */
  secret?: string;
  /** Optional - the definition of the device profile that this device should use. */
  deviceProfileOverride?: DeviceProfile;
}

export interface PagedBackendDevices {
  items?: BackendDevice[];
  _links?: Links;
}

export interface BackendDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /**
   * The identifier for the parent device.
   * @example "40cad82b-61a5-4bd8-9161-b06bf51525e7"
   */
  parentDeviceId?: string;
  /** Device ids for all child devices of the device. */
  childDeviceIds?: string[];
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type?: DeviceIntegrationType;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  profileId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs that were stored in the conductor for the device.
   * If the metadata contains a "public" key that will be included in the details based on the backend type through
   * the public API, only keys that are defined in the swagger will be populated.
   * If "mnmn", "vid", "ocfDeviceType" keys are present they will override values from the device profile.
   * If the metadata includes "deviceNetworkId" it will be synchronized to DM.
   */
  metadata?: Record<string, object>;
}

export interface BackendDeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceEvent[];
}

export interface DeviceEvent {
  /** @example "main" */
  componentId?: string;
  /** @example "switch" */
  capability?: string;
  /** @example "switch" */
  attribute?: string;
  /** The id on the command that trigged this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
  state?: AttributeState;
  visibility?: EventVisibilityData;
  providerData?: DeviceEventProviderData;
}

export interface EventVisibilityData {
  /**
   * Indicates whether the event should be displayed in the history feed.
   * This is used because some device attributes are very chatty.
   */
  displayed?: boolean;
  /**
   * Indicates if the event cannot be stored for longer than the standard 7 day recent history.
   * This can be based on legal obligations.
   */
  nonArchivable?: boolean;
  /**
   * Indicates whether the event history should be stored in recent history (7 days).
   * This can be based on legal obligations.
   */
  ephemeral?: boolean;
}

export interface DeviceEventProviderData {
  /**
   * The UNIX time that the event occured according to the provider.
   * @format int64
   */
  timestamp?: number;
  /**
   * An increasing 64 bit (long) number that represents an ordering of events from the producer.
   * Higher numbers represent more recent events. If this is provided it will be taken into
   * consideration in state change determination but will not affect broadcast of the event.
   * There may be gaps in the sequence.
   * @format int64
   * @example 797606
   */
  sequenceNumber?: number;
  /**
   * A foreign event id used to correlate logs.
   * @maxLength 36
   */
  eventId?: string;
  /**
   * If the provider knows if the event represents a state change they may signal that.
   * Even if the event is not considered a state change from the provider the state of the device
   * may be updated if it is out of sync.
   * @default "UNKNOWN"
   */
  stateChange: 'Y' | 'N' | 'UNKNOWN';
  /**
   * Event data that is not translated into SmartThings capabilities.
   * @maxLength 1000
   */
  rawData?: string;
}

/**
 * the status of the requested device group
 * @example {"deviceGroupId":"457d79d1-4685-4852-89b6-e2fc681a590f","devices":{"dev1":{"components":{"main":{"switch":{"switch":{"value":["on"]}}}}},"dev2":{"components":{"subComponent":{"switch":{"switch":{"value":["off"]}}}}}},"groupAggregate":{"switch":{"switch":{"value":["off"]}}}}
 */
export interface DeviceGroupStatusResponse {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  deviceGroupId?: string;
  devices?: Record<
    string,
    {
      /**
       * A map of componentId to Component status.
       * @example {"main":{"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}}
       */
      components?: Record<string, ComponentStatus>;
      healthState?: {
        /** Current state of the device */
        state?: 'ONLINE' | 'OFFLINE';
        /**
         * Last reported date/time in UTC
         * @format date-time
         */
        lastUpdatedDate?: string;
      };
    }
  >;
  groupAggregate?: Record<string, Record<string, AttributeState>>;
}

export interface InternalDevice {
  /**
   * the device id
   * @example "51b5dc55-f856-49cd-bf89-da6f54e244b2"
   */
  id: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "Joe's room light"
   */
  label: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * Used to communicate a unique identifier to DM so that things like the Alexa integration can recognize the
   * uniqueness of the device. We are using this field because it exists in DM and is not used by profile based
   * devices yet.
   */
  deviceNetworkId?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  mnmn?: string;
  /**
   * The User UUID for the owner of the device when applicable
   * @format uuid
   */
  ownerId?: string;
  vid?: string;
  ocfDeviceType?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * Device creation time (since epoch)
   * @format int64
   * @example 1634226746547
   */
  dateCreated?: number;
  /**
   * the external id for the device (foreign system id)
   * @example "switch-123"
   */
  externalId?: string;
  /**
   * the installed app id (owner) for ENDPOINT_APP device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  installedAppId?: string;
  /**
   * the device profile id if applicable for the device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  profileId?: string;
  /**
   * the Groovy installed app id for DTH device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  installedGroovyAppId?: string;
  /** a list of components for DTH (non profile) type devices */
  components?: {
    /** @example "main" */
    id?: string;
    /** @example "comp1" */
    label?: string;
    /**
     * The identifier for the device's DeviceType.
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
     */
    deviceTypeId?: string;
  }[];
  /**
   * The name for the device's DeviceType for DTH type devices.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName?: string;
  /**
   * The device network type if applicable for DTH type devices.
   * @example "ZWAVE"
   */
  deviceNetworkType?: string;
  /**
   * The hub that the device is connected to.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
   */
  hubId?: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: boolean;
  /**
   * The room of the device.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
   */
  roomId?: string;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel: DeviceNetworkSecurityLevel;
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup?: boolean;
  /**
   * A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header to Gizmo.
   * This will be used in the migration to Peddler for device events and should be a key for the Hub so only that
   * can cause updates to the device.
   */
  secret?: string;
  /**
   * The id of this device's parent.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  parentDeviceId?: string;
}

export interface InternalCommands {
  actor?: {
    actorType?: 'GROOVY_APP' | 'USER';
    groovyApp?: {
      installedAppId?: string;
    };
    user?: {
      clientId?: string;
      userId?: string;
    };
  };
  commands?: DeviceCommand[];
}

export type JsonObject = Record<string, object>;

export type DeleteDeviceCommandsResponse = object;

export interface PagedDeviceCategories {
  items?: DeviceCategoryDetails[];
  _links?: Links;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategoryDetails {
  /** @example "Light" */
  name: string;
  /** @example "oic.d.light" */
  resourceType: string;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategory {
  /** @example "Light" */
  name: string;
  /** @default "manufacturer" */
  categoryType: 'manufacturer' | 'user';
}

export interface GroupDeviceDetails {
  /** @example "My Group" */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
     */
    deviceId: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
}

/**
 * The type of the group in question
 *
 * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
 */
export enum DeviceGroupType {
  UNDETERMINED = 'UNDETERMINED',
  GENERIC = 'GENERIC',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
  LIGHTING = 'LIGHTING',
}

/** @example {"groupName":"helloWorldGroup","deviceGroupId":"457d79d1-4685-4852-89b6-e2fc681a590f","devices":{"30d3691f-2416-4cbc-b193-2329581f300d2":{"components":{"main":{"switch":{"switch":{"value":["on"]}}}}},"30d7421f-2416-4cbc-b193-2329581f29d1":{"components":{"subComponent":{"switch":{"switch":{"value":["off"]}}}}}},"groupAggregate":{"switch":{"switch":{"value":["off"]}}}} */
export interface DeviceGroupStatusGizmoResponse {
  /** Name of the group created */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  deviceGroupId?: string;
  devices?: Record<string, DeviceStatus>;
  groupAggregate?: Record<string, CapabilityStatus>;
}

/** A group */
export interface DeviceGroupCreateRequest {
  /** Name of the group created */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /**
   * Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands.
   * @default false
   */
  summaryGroup?: boolean;
}

/** A group */
export interface DeviceGroupUpdateRequest {
  /** Name of the group */
  groupName: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
}

/** A group */
export interface DeviceGroupResponse {
  /**
   * Name of the group created
   * @example "helloWorldGroup"
   */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType: DeviceGroupType;
  /**
   * Location where this group is
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  locationId?: string;
  /** restriction tier of the device group */
  restrictionTier?: number;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
  /**
   * a GUID that identifies a group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  deviceGroupId: string;
  /** Lowest common denominator capability of all the devices in the group */
  deviceGroupCapabilities: DeviceGroupCapability[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /** Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands. */
  summaryGroup: boolean;
}

/** A paginated array of device groups */
export interface PagedDeviceGroups {
  items?: DeviceGroupResponse[];
  _links?: Links;
}

/** @example {"switch":{"switch":{"value":"on","unit":null}}} */
export type DeviceAttributesPerCapability = Record<string, DeviceAttributes>;

/** @example {"switch":{"value":"on","unit":null}} */
export type DeviceAttributes = Record<string, AttributeData>;

export interface AttributeData {
  value?: object;
  unit?: string;
  data?: Record<string, any>;
}

export interface DeviceGroupCommandRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceGroupCommand[];
}

/** @example {"capability":"switchLevel","command":"setLevel","arguments":[100,1]} */
export interface DeviceGroupCommand {
  capability?: string;
  command?: string;
  arguments?: object[];
}

export type DeviceGroupDeleteResponse = Record<string, any>;

export type DeviceGroupCommandResponse = Record<string, any>;

export type DeviceGroupUpdateDeviceRequest = Record<string, any>;

export type DeviceGroupDeleteDeviceResponse = Record<string, any>;

export type DeviceGroupUpdateDeviceResponse = Record<string, any>;

/** The capability that is common to all devices in the group */
export interface DeviceGroupCapability {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

/** Internal device group representation */
export interface InternalDeviceGroup {
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "457d79d1-4685-4852-89b6-e2fc681a590f"
   */
  deviceGroupId?: string;
  /** Name of the group created */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
}

/**
 * An object to represent a device belonging to room.
 * @example {"deviceId":"30d3691f-2416-4cbc-b193-2329581f29d1"}
 */
export interface AddRoomDeviceInfo {
  /** @example "30d3691f-2416-4cbc-b193-2329581f29d1" */
  deviceId: string;
  /** Future field , currently not used (Device order within the room) */
  sortOrder?: number;
}

/** A request object to add devices to room */
export interface AddDevicesToRoomRequest {
  items: AddRoomDeviceInfo[];
}

/** A request object to update the device profile for a specific device */
export interface UpdateDeviceProfileRequest {
  /**
   * The updated device profile ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  profileId?: string;
}

/** @example {} */
export type AddDevicesToRoomResponse = object;

/** A request object to delete devices from room. */
export interface RemoveDevicesFromRoomRequest {
  devices: string[];
}

/** @example {} */
export type RemoveDevicesFromRoomResponse = object;

export interface PagedRoomDevices {
  items?: Device[];
  _links?: Links;
}

export type DeviceHealthResponse = DeviceHealthState & {
  /** @minItems 0 */
  children?: DeviceHealthState[];
};

export interface DeviceHealthState {
  /** Id of the device */
  deviceId: string;
  state: HealthState;
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate: string;
}

export interface InternalDeviceHealthRequest {
  /** Id of the device */
  deviceId?: string;
  state: HealthState;
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

export interface UpdateDeviceHealthRequest {
  /**
   * Health state to set the root device to.
   * Can be null if descendants value provided, required otherwise.
   */
  state?: HealthState;
  /**
   * Flat list of state updates for descendants anywhere in the subtree.
   *
   * Use this to control the state of a subset of the children at once i.e. a radio is down.
   * Parent being offline still overrules child state.
   */
  descendants?: UpdateChildDeviceHealth[];
}

export interface UpdateChildDeviceHealth {
  deviceId: string;
  /** value to set child devices health state to */
  state: HealthState;
}

export enum HealthState {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface DeviceHealthEnrollmentResponse {
  /** The minimum number of seconds between pings to the device. Null when the device is not configured to be monitored. */
  checkInterval?: number;
  /**
   * Flat list of all descendants enrollment data. Only present if children requested.
   * @minItems 0
   */
  descendants?: DescendantDeviceHealthEnrollment[];
}

export interface DescendantDeviceHealthEnrollment {
  deviceId: string;
  /** The number of seconds between pings to the device. Null when the device is not configured to be monitored. */
  checkInterval?: number;
}

export type DeviceProfile = DeviceProfileResponse & {
  /** A typed model which provides information around ownership of a specific domain. */
  owner?: Owner;
};

export type DeviceProfileResponse = DeviceProfileBase &
  DeviceProfileMigrationStatus & {
    /**
     * The lifecycle status of a device profile.
     * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
     * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
     */
    status?: DeviceProfileStatus;
    preferences?: PreferenceResponse[];
    components?: DeviceComponent[];
  };

export interface DeviceProfileBase {
  /** @example "a362ddb6-349b-4650-9911-681b51069a57" */
  id?: string;
  /** @example "thermostat1.model1" */
  name?: string;
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** The restriction to limit actions a device can take. */
  restrictions?: DeviceRestriction;
}

/**
 * Additional information about the device profile, limited to 10 entries.
 * @example {"firmWareVersion":"0.2.123","manufacturerName":"SmartThingsCommunity"}
 */
export type DeviceProfileMetadata = any;

/** The restriction to limit actions a device can take. */
export type DeviceRestriction = Restriction;

/** Describes the migration status (from v1 -> v2). This profile will be available in a backwards compatible fashion regardless. */
export interface DeviceProfileMigrationStatus {
  /** @default "NOT_MIGRATED" */
  migrationStatus: 'MIGRATED' | 'NOT_MIGRATED';
}

/**
 * The lifecycle status of a device profile.
 * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
 * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
 * @default "DEVELOPMENT"
 */
export enum DeviceProfileStatus {
  DEVELOPMENT = 'DEVELOPMENT',
  PUBLISHED = 'PUBLISHED',
}

export type DeviceMigrationResponse = object;

export interface DeviceShareRequest {
  share?: DeviceShare[];
}

export interface DeviceShare {
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  shareType?: 'ADD' | 'REMOVE';
}

export type DeviceShareResponse = object;

/** An OCF device representation that matches the oic/p device representation */
export interface OcfDeviceProfile {
  /**
   * The label for the device
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /** @format uuid */
  deviceId?: string;
  /** Manufacturer's name */
  mnmn?: string;
  /** Vendor (model) ID */
  vid?: string;
  /** Manufacturer's code */
  mfc?: string;
  /** LocationId for the device */
  locationId?: string;
  /**
   * The User UUID for the owner of the device when applicable
   * @format uuid
   */
  ownerId?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  deviceBackendType?: DeviceIntegrationType;
  /** The device network type */
  deviceNetworkType?: string;
  /** the room that the device is assigned to */
  roomId?: string;
  /** The DTH device type name. This should not be depended on! */
  deviceTypeName?: string;
  /** The DTH device type id. This should not be depended on! */
  deviceTypeId?: string;
  /** The profile Id that the device is using for non-DTH devices. This should not be depended on! It does not work for DIPs */
  deviceProfileId?: string;
  /** The OCF device type assigned to the device */
  ocfDeviceType?: string;
}

export interface PreferenceResponse {
  /** The ID of the preference */
  preferenceId?: string;
  /** An alphanumeric English language name for this preference. */
  name?: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

/**
 * The definition of this preference.
 * @example {"id":"example.colorSelect","name":"colorSelect","title":"Color Select","description":"Select a preset color","required":false,"preferenceType":"enumeration","definition":{"options":{"red":"Red","yellow":"Yellow","lightBlue":"Light Blue"},"default":"red"}}
 */
export type EnumerationPreference = PreferenceResponse & {
  definition: {
    /** The available selections for an `enumeration` preference. */
    options: Record<string, string>;
    /** Default value for a preference. */
    default?: any;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.notificationMessage","name":"notificationMessage","title":"Notification Message","description":"Set the text of the notification message","preferenceType":"string","definition":{"stringType":"text","minLength":1,"maxLength":10}}
 */
export type StringPreference = PreferenceResponse & {
  definition?: {
    /** Minimum length a string may be set to. */
    minLength?: number;
    /** Maximum length a string may be set to. */
    maxLength?: number;
    /**
     * The type of a string preference.
     * `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes.
     * @default "text"
     */
    stringType?: 'text' | 'password' | 'paragraph';
    /** Default value for a preference. */
    default?: string;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.tempOffset","name":"tempOffset","title":"Temperature Offset","description":"Set the default temperature offset of this device","required":false,"preferenceType":"integer","definition":{"minimum":-10,"maximum":10,"default":0}}
 */
export type IntegerPreference = PreferenceResponse & {
  definition?: {
    /** Minimum value a preference may be set to. */
    minimum?: number;
    /** Maximum value a preference may be set to. */
    maximum?: number;
    /** Default value for a preference. */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.lightToggleDelay","name":"lightToggleDelay","title":"Light Toggle Delay","description":"The delay time to toggle a light to turn on or off","required":false,"preferenceType":"number","definition":{"minimum":0,"maximum":1,"default":0.5}}
 */
export type NumberPreference = PreferenceResponse & {
  definition?: {
    /**
     * Minimum value a preference may be set to.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to.
     * @format double
     */
    maximum?: number;
    /**
     * Default value for a preference.
     * @format double
     */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.featureEnabled","name":"featureEnabled","title":"Feature Enabled","description":"Set the feature to enabled for this device","required":false,"preferenceType":"boolean","definition":{"default":true}}
 */
export type BooleanPreference = PreferenceResponse & {
  definition?: {
    /** Default value for a preference. */
    default?: boolean;
  };
};

/** The type of preference this is. */
export enum PreferenceType {
  Integer = 'integer',
  Number = 'number',
  Boolean = 'boolean',
  String = 'string',
  Enumeration = 'enumeration',
}

export interface PreferenceValue {
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

export type IntegerPreferenceValue = PreferenceValue & {
  value: number;
};

export type NumberPreferenceValue = PreferenceValue & {
  value: number;
};

export type BooleanPreferenceValue = PreferenceValue & {
  value: boolean;
};

export type StringPreferenceValue = PreferenceValue & {
  value: string;
};

/** @example {"values":{"temperatureOffset":{"preferenceType":"integer","value":3},"example.lightToggleDelay":{"preferenceType":"number","value":0.68},"example.featureEnabled":{"preferenceType":"boolean","value":false},"example.notificationMessage":{"preferenceType":"string","value":"It is hot"},"example.colorSelect":{"preferenceType":"string","value":"lightBlue"}}} */
export interface DevicePreferenceResponse {
  /** Map of PreferenceId to its stored values */
  values?: Record<string, PreferenceValue>;
}

export type ExtendedDevicePreferenceResponse = DevicePreferenceResponse & {
  /** Map of PreferenceId to its definitions */
  definitions?: Record<string, PreferenceResponse>;
};

/** @example {"value":3} */
export interface UpdateDeviceParameterRequest {
  value: object;
}

export interface Session {
  /** ID of the test session */
  test_session_id: string;
}

export interface InitTest {
  /** ID of the device to generate DTP */
  device_id: string;
}

export interface StartTest {
  /** ID of the test session */
  test_session_id: string;
  dtp_settings?: DTPSettings;
}

export interface DeviceList {
  devices: {
    /** SmartThings ID of the device */
    deviceId?: string;
    /** SmartThings name field of the device */
    name?: string;
    /** SmartThings label field of the device (Name of the device in ST App) */
    label?: string;
    /** Manufacturer code as detailed by device or integration */
    deviceManufacturerCode?: string;
    /** Type of device as reported by SmartThings API */
    type?: string;
  }[];
}

export interface SessionList {
  tests: SessionState[];
}

export interface SessionState {
  /** Session state */
  runState: 'ONGOING' | 'FINISHED';
  /** Session identifier generated by Test Suite */
  sessionId: string;
  /** SmartThings label field of the device (Name of the device in ST App) for which this session was generated */
  deviceName?: string;
  /** SmartThings device ID for the device for which this session was generated */
  deviceId: string;
  /** Test session execution status */
  testStatus: 'IN_PROGRESS' | 'COMPLETED' | 'CANCELED' | 'ERROR' | 'CLOSED_BY_ADMIN' | 'FAILURES';
  /** Whether this test session was marked for cancellation or not */
  isCanceling?: boolean;
  /** Object storing some numerical data about test progression */
  statusData?: {
    /** Number of actions to be executed */
    total?: number;
    /** Number of completed actions */
    completed?: number;
    /** Number of passed actions */
    passed?: number;
    /** Number of failed actions */
    failures?: number;
    /** Number of errors */
    errors?: number;
    /** Number of actions skipped due to failure or error */
    skipped?: number;
    /** Number of actions skipped by user during user instruction */
    user_skipped?: number;
  };
  /**
   * Time when report was generated
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  endTime?: string;
  /** If true this test session is marked as valid for Certification */
  certificationFlag?: boolean;
  /** Number of miliseconds from when test started up to now or test end (whichever is shorter) */
  duration?: number;
}

export interface TestSessionCreated {
  /** Test Session ID */
  status: 'accepted' | 'refused';
  /** Test Session ID. If status was accepted it is new test session id created. If it was refused then last test session id on this device is provided */
  test_session_id: string;
  /** If status was refused, this describes why it was refused */
  description?: string;
  /** Common class describing element of Device Test Plan */
  dtp?: DTPNode;
}

export interface TestSessionResponse {
  /** Test Session ID */
  status: 'accepted' | 'refused';
  /** If status was refused, this describes why it was refused */
  description?: string;
}

/** Test session report */
export interface TestSessionReport {
  /**
   * Time when report was generated
   * @format date-time
   * @example "2022-06-22T13:30:00Z"
   */
  reportGenerationTime?: string;
}

/** Common class describing element of Device Test Plan */
export interface DTPNode {
  /** Identifier of this element, it is used as part of DTPNodePath */
  id?: string;
  /** Human readable name for this element */
  name?: string;
  /** Human readable description for this element */
  description?: string;
  /** Type of element. It serves only informative purpose */
  elementType?: 'ROOT' | 'DEVICE' | 'COMPONENT' | 'CAPABILITY' | 'TEST_CASE' | 'STEP' | 'ACTION';
  /** Defines what exactly needs to be executed by executor */
  executorInstructions?: ExecutionInstructions;
  /** List of other DTP Nodes */
  childElements?: DTPNode[];
}

/**
 * DTP Node reference key
 * @pattern ^[a-zA-Z0-9/\.\-_]*$
 */
export type DTPNodePath = string;

export interface DTPSettings {
  /** All nodes specified here will be excluded */
  excludeList?: DTPNodePath[];
}

/** Defines what exactly needs to be executed by executor */
export interface ExecutionInstructions {
  /** Execution type */
  execution_type: ExecutionType;
}

/** Defines major configuration, session ID, types of infrastructure and so one, pertaining to entire test */
export type ExecutionInitInstruction = ExecutionInstructions & {
  /** Id of session to which this DTP is assigned */
  session_id?: string;
  /** Name of DTP, currently based upon session id */
  name?: string;
  /**
   * Defines number of times this plan is to be repeated
   * @min 1
   */
  iterations?: number;
  /**
   * Defines time spent waiting between iterations
   * @min 0
   */
  interval?: number;
  /** Used in some postprocessors as a label */
  shard?: string;
  /** Used in some postprocessors as a label */
  environment?: string;
  /** Used in some postprocessors as a tags */
  tags?: string[];
  /** Key of elements here defines which kind of infrastructure object to spawn. This must be ST_Cloud or User at this point. */
  infrastructure?: {
    ST_Cloud?: {
      /** Encrypted token (Will be decrypted by KMS) or Decrypted token or reference to postprocesor which will provide it (currently last one is done by: $.post this will look for first SuiteDumper postprocesor and ask it to provide token) */
      token?: string;
      /**
       * API endpoint to use
       * @default "https://api.smartthings.com"
       */
      endpoint?: string;
    };
    /** Defines Interactive test interface */
    User?: object;
  };
  postprocessors?: {
    /** Describes which postprocessor to load */
    name?: string;
  }[];
};

/** Defines initial states that need to be met before some other instruction */
export type InitialStatesInstruction = ExecutionInstructions & {
  requirements?: {
    /** If even one check from this array is not met, it will result in skipping this execution and writing value defined in if_not as this node state */
    dependUpon?: {
      /** Path to node which to check, with elements separated with '/'. empty string ('') and 'root' are considered as root element, '.' means same element, '..' means parent element, all other strings will be treated as ids.  */
      path?: string;
      /** Name of status which should be set upon selected node in path */
      status?: string;
    }[];
    /**
     * Value to type upon skipping this task
     * @default "SKIPPED"
     */
    if_not?: string;
  };
  /**
   * Defines time spent awaiting for arriving events for wrong initial states
   * @min 0
   */
  timeout?: number;
  /**
   * Defines time spent awaiting for additional events after all expected initial states events arrived
   * @min 0
   */
  delay?: number;
  initial_states?: {
    /**
     * Which interface will facilitate this initial_state
     * @pattern ^ST_Cloud|User$
     */
    type?: string;
    /**
     * Device identifier under interface to which this check is to be performed
     * @pattern ^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$
     */
    deviceId?: string;
    /**
     * In which component under this device this check is to be performed
     * @default "main"
     */
    component?: string;
    /** in which capability under this component this check is to be performed */
    capability?: string;
    /** In which attribute under this capability this check is to be performed */
    attribute?: string;
    /** Which value is expected under device+componentent+capability+attribute. This will casted to string and compared letter after letter as detailed: https://smartthings.atlassian.net/wiki/spaces/WTS/pages/2338293886/Value+handling */
    value?: any;
    returnCommand?: {
      /**
       * Which interface will facilitate this command
       * @pattern ^ST_Cloud|User$
       */
      type?: string;
      /**
       * Device identifier under interface to which this command is directed
       * @pattern ^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$
       */
      deviceId?: string;
      /**
       * To which component under this device this command is directed
       * @default "main"
       */
      component?: string;
      /** To which capability under this component this command is directed */
      capability?: string;
      /** Name of command to execute on this device+component+capability */
      command_name?: string;
      /** Array of parameters to pass to SmartThings command. They will be passed as they are here. Since different commands have different parameters it is infeasible to describe everything here */
      params?: any[];
    };
  }[];
};

/** Defines command and expected events/states that should happen after command execution */
export type CommandValidateInstruction = ExecutionInstructions & {
  requirements?: {
    /** If even one check from this array is not met, it will result in skipping this execution and writing value defined in if_not as this node state */
    dependUpon?: {
      /** Path to node which to check, with elements separated with '/'. empty string ('') and 'root' are considered as root element, '.' means same element, '..' means parent element, all other strings will be treated as ids.  */
      path?: string;
      /** Name of status which should be set upon selected node in path */
      status?: string;
    }[];
    /**
     * Value to type upon skipping this task
     * @default "SKIPPED"
     */
    if_not?: string;
  };
  /**
   * Defines time spent awaiting for arriving events for expected_events
   * @min 0
   */
  timeout?: number;
  /**
   * Defines time spent awaiting for additional events after all expected events arrived
   * @min 0
   */
  delay?: number;
  /**
   * Which interface will facilitate this command
   * @pattern ^ST_Cloud|User$
   */
  type?: string;
  /**
   * Device identifier under interface to which this command is directed
   * @pattern ^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$
   */
  deviceId?: string;
  /**
   * To which component under this device this command is directed
   * @default "main"
   */
  component?: string;
  /** To which capability under this component this command is directed */
  capability?: string;
  /** Name of command to execute on this device+component+capability */
  command_name?: string;
  /** Array of parameters to pass to SmartThings command. They will be passed as they are here. Since different commands have different parameters it is infeasible to describe everything here */
  params?: any[];
  expected_events?: {
    /**
     * Which interface will facilitate this expected event
     * @pattern ^ST_Cloud|User$
     */
    type?: string;
    /**
     * Device identifier under interface to which this check is to be performed
     * @pattern ^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$
     */
    deviceId?: string;
    /**
     * In which component under this device this check is to be performed
     * @default "main"
     */
    component?: string;
    /** in which capability under this component this check is to be performed */
    capability?: string;
    /** In which attribute under this capability this check is to be performed */
    attribute?: string;
    /** Which value is expected under device+componentent+capability+attribute. This will casted to string and compared letter after letter as detailed: https://smartthings.atlassian.net/wiki/spaces/WTS/pages/2338293886/Value+handling */
    value?: any;
  }[];
};

/** Defines command that needs to be sent */
export type CommandInstruction = ExecutionInstructions & {
  requirements?: {
    /** If even one check from this array is not met, it will result in skipping this execution and writing value defined in if_not as this node state */
    dependUpon?: {
      /** Path to node which to check, with elements separated with '/'. empty string ('') and 'root' are considered as root element, '.' means same element, '..' means parent element, all other strings will be treated as ids.  */
      path?: string;
      /** Name of status which should be set upon selected node in path */
      status?: string;
    }[];
    /**
     * Value to type upon skipping this task
     * @default "SKIPPED"
     */
    if_not?: string;
  };
  /**
   * Defines time spent awaiting for arriving events for expected_events
   * @min 0
   */
  timeout?: number;
  /**
   * Defines time spent awaiting for additional events after all expected events arrived
   * @min 0
   */
  delay?: number;
  /**
   * Which interface will facilitate this command
   * @pattern ^ST_Cloud|User$
   */
  type?: string;
  /**
   * Device identifier under interface to which this command is directed
   * @pattern ^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$
   */
  deviceId?: string;
  /**
   * To which component under this device this command is directed
   * @default "main"
   */
  component?: string;
  /** To which capability under this component this command is directed */
  capability?: string;
  /** Name of command to execute on this device+component+capability */
  command_name?: string;
  /** Array of parameters to pass to SmartThings command. They will be passed as they are here. Since different commands have different parameters it is infeasible to describe everything here */
  params?: any[];
};

/** Execution type */
export enum ExecutionType {
  DtInitTestContext = 'dt-init-test-context',
  DtInitStates = 'dt-init-states',
  DtSendCommandValidate = 'dt-send-command-validate',
  DtSendCommand = 'dt-send-command',
}

export interface ProductCategory {
  /**
   * id of the product category
   * @format uuid
   */
  productCategoryId: string;
  /** name of the product category */
  productCategoryName: string;
}

export interface OrganizationMember {
  /**
   * Email address for the member.
   * @example "user@acme.com"
   */
  email: string;
  /**
   * A raw user principal (user uuid).
   * @format uuid
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  principal: string;
  /**
   * @default "RAW"
   * @example "RAW"
   */
  principalType?: 'RAW';
}

export interface PastoraOrganizationMember {
  /**
   * The user's uuid
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  userId?: string;
  /** The member's name. Is null when the user hasn’t accepted the invite and is not in the organization yet */
  memberName?: string;
  /** The member's email */
  memberEmail: string;
  /** The current role of the member, or the role in which the member was invited to have */
  role: OrganizationMemberRole;
  status: OrganizationMemberStatus;
  /**
   * The inviteId if the member has a status of INVITED
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  inviteId?: string;
}

export enum OrganizationMemberStatus {
  MEMBER = 'MEMBER',
  INVITED = 'INVITED',
}

/** The current role of the member, or the role in which the member was invited to have */
export enum OrganizationMemberRole {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
}

/**
 * The name of the driver
 * @format ^[a-zA-Z0-9 _\/\\-()\[\]{}\.]{1,50}$
 * @example "Generic Button"
 */
export type DriverName = string;

export interface DriverPermission {
  /** Name of the permission */
  name: string;
  /** Additional properties on a driver permission */
  attributes: PermissionAttributes;
}

/**
 * @maxItems 100
 * @minItems 0
 */
export type DriverPermissions = DriverPermission[];

/** The version of the driver revision being returned */
export type DriverVersion = string;

/**
 * A user scoped package key that's used to lookup the respective driver record
 * @pattern ^[a-zA-Z0-9 _/\\\-()\\[\\]{}\.]{1,36}$
 * @example "smartthings.zigbee.bulb-rgbw"
 */
export type PackageKey = string;

export interface PagedDriver {
  /** The ID of the Sprocket driver */
  driverId: DriverId;
  /** The name of the driver */
  name: DriverName;
  /** A user scoped package key that's used to lookup the respective driver record */
  packageKey: PackageKey;
  /**
   * @maxItems 100
   * @minItems 0
   */
  deviceIntegrationProfiles?: DeviceIntegrationProfileKey[];
  permissions?: DriverPermissions;
  /** The version of the driver revision being returned */
  version?: DriverVersion;
}

/** Additional properties on a driver permission */
export type PermissionAttributes = Record<string, object>;

/** Support information of the driver's vendor */
export type VendorSupportInformation = string;

export type Driver = PagedDriver & {
  /** Support information of the driver's vendor */
  vendorSupportInformation?: VendorSupportInformation;
  /**
   * @maxItems 100
   * @minItems 0
   */
  fingerprints: Fingerprint[];
};

export interface SimpleDriver {
  /** The ID of the Sprocket driver */
  driverId: DriverId;
  /** The name of the driver */
  name: DriverName;
  /**
   * @maxItems 100
   * @minItems 0
   */
  deviceIntegrationProfiles?: DeviceIntegrationProfileKey[];
  /**
   * @maxItems 100
   * @minItems 0
   */
  fingerprints?: SimpleDriverFingerprint[];
}

export interface SimpleDriverFingerprint {
  /** The identifier for the respective fingerprint, unique per driver */
  id: FingerprintId;
  type: 'ZIGBEE' | 'ZWAVE' | 'MATTER';
  /** Label assigned to device at join time. If this is not set the driver name is used. */
  deviceLabel?: FingerprintDeviceLabel;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  matter?: MatterManufacturerInfo;
}

export interface EdgeDeviceUpdateRequest {
  /**
   * Unique Identifier of the driver
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  driverId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Simple object response for deleted entity. */
export type DeleteResponse = Record<string, any>;

/** Request body for sending organization invites to users. */
export interface BorgInviteRequest {
  /**
   * Individuals to invite to an organization with a role.
   * @maxItems 20
   */
  invitees?: InviteRequestItem[];
}

export type InviteRequest = BorgInviteRequest & {
  /**
   * The E-mail address of the invitor.
   * @example "person@people.net"
   */
  invitor?: string;
};

/** Invidiual member to invite to an organization. */
export interface InviteRequestItem {
  /** The E-mail address of the invited party. */
  email: Email;
  role: Role;
}

/** Request body for sending organization invites to users. */
export interface InviteResponse {
  /** A list of developer users to invite to the organization. */
  results?: InviteResponseItem[];
}

/** The status for an individual organization member invitation. */
export type InviteResponseItem = InviteRequestItem & {
  /**
   * Status code for this invite entry.
   * @example 200
   */
  status: number;
  /**
   * Information on the individual invitation.
   * @example "Success"
   */
  info: string;
  /** Invite ID for sucessfully created invitations. */
  inviteId?: string;
  /** The URL the invitee can follow to accept a successful invitation (they must be logged in). */
  acceptUrl?: string;
};

/**
 * A member to be modified according to the available types of modifications.
 * For a `CHANGE_ROLE` modification, the `role` property will be required.
 */
export interface ModifyMemberItem {
  member: OrganizationMember;
  /** The modification to make to an organization member. */
  modification: Modification;
  role?: Role;
}

export interface ModifyMembersRequest {
  users?: ModifyMemberItem[];
}

export interface ModifyUsersErrorList {
  users?: OrganizationMember[];
}

/** User specifiable fields on Organization creation. Returned fields may be limited depending on access level. */
export type OrganizationCreateRequest = OrganizationUpdateRequest & {
  /** Manufacturer name for the organization. */
  manufacturerName?: ManufacturerName;
  /**
   * A unique name for an organization. Alphanumeric names only (no spaces or special characters)
   * must start with a letter. This will be the "namespace" for the custom capabilities for this org.
   */
  name: OrganizationName;
};

/** An internal platform representation of a developer organization. */
export type OrganizationResponse = OrganizationCreateRequest & {
  /** The user group for organization developers. */
  developerGroupId?: string;
  /** The user group for organization admins. */
  adminGroupId?: string;
  /**
   * A generated UUID for an organization.
   * @format uuid
   */
  organizationId: string;
  /**
   * Denotes whether this is the default user org for the caller.
   * @default false
   */
  isDefaultUserOrg?: boolean;
};

export type OrganizationResponseList = OrganizationResponse[];

/** Request body to update the mutable fields of a developer organization. `NOTE`: warehouseGroupId cannot be updated from a present to a null value */
export interface OrganizationUpdateRequest {
  /** A pretty name for a developer organization. */
  label?: Label;
  /** The groupId that corresponds to this organization in warehouse. */
  warehouseGroupId?: WarehouseGroupId;
  /** Legacy `mnId` (also `mnid`) field used by some Samsung services. */
  mnId?: MnId;
}

/**
 * The E-mail address of the invited party.
 * @example "person@people.net"
 */
export type Email = string;

/**
 * A pretty name for a developer organization.
 * @min 3
 * @max 256
 * @example "Shoes n' Boots"
 */
export type Label = string;

/**
 * Manufacturer name for the organization.
 * @example "ShoeBoots"
 */
export type ManufacturerName = string;

/**
 * The modification to make to an organization member.
 * @example "CHANGE_ROLE"
 */
export enum Modification {
  REMOVE = 'REMOVE',
  CHANGE_ROLE = 'CHANGE_ROLE',
}

/**
 * Legacy `mnId` (also `mnid`) field used by some Samsung services.
 * @example "ShoeBoots"
 */
export type MnId = string;

/**
 * A unique name for an organization. Alphanumeric names only (no spaces or special characters)
 * must start with a letter. This will be the "namespace" for the custom capabilities for this org.
 * @min 3
 * @max 128
 * @example "shoesNBoots1"
 */
export type OrganizationName = string;

/** @example "ADMIN" */
export enum Role {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
}

/**
 * The groupId that corresponds to this organization in warehouse.
 * @format uuid
 * @example "81bfb21a-8716-410b-b2c7-40c14f585b60"
 */
export type WarehouseGroupId = string;

export interface MatchedProfile {
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  deviceprofile?: DeviceProfile;
}

export interface DevPortalResponse {
  StatusCode?: number;
  StatusMsg?: string;
}

export type AccountInfoResponse = DevPortalResponse & {
  Data?: {
    AccountInfo?: AccountInfo;
  }[];
};

export type ContactAccountsResponse = DevPortalResponse & {
  Data?: {
    AccountMNid?: string;
  }[];
};

export type ContactEnrollDataResponse = DevPortalResponse & {
  Data?: ContactEnrollData;
};

export type AccountV1Response = DevPortalResponse & {
  Data?: AccountV1[];
};

export type AccountContactsResponse = DevPortalResponse & {
  Data?: Member[];
};

export interface ContactEnrollData {
  ContactInfo?: DpContactInfo;
  AccountList?: Account[];
}

export interface DpContactInfo {
  Id?: string;
  SAguid?: string;
  PartnerId?: string;
  Name?: string;
  Email?: string;
}

export interface Account {
  EnrollStatus?: string;
  Roles?: string[];
  AccountInfo?: AccountInfo;
  AdminList?: AdminInfo[];
}

export interface AccountInfo {
  Id?: string;
  Name?: string;
  MNid?: string;
  PartnerId?: string;
  Email?: string;
  NationalCode?: string;
  Description?: string;
}

export interface AdminInfo {
  SAguid?: string;
  Name?: string;
  Roles?: string;
  Email?: string;
}

export interface AccountV1 {
  MNid__c?: string;
}

export interface Member {
  SAguid?: string;
  Roles?: string;
}

export interface GetProductAnalyticsParams {
  /** The product ids to filter the data by. */
  productId?: string[];
  /** The regions to fetch data for, defaults to Global */
  region?: string[];
  /** The measure to fetch data for, at least one of `active_devices`, `registered_devices` */
  measure: string[];
  /** unix timestamp to query data */
  from: number;
  /** unix timestamp to query data */
  to: number;
}

export interface UploadBrandIconPayload {
  /** Icon to upload */
  icon: File;
}

export interface ListDriversParams {
  /**
   * A list of Driver ids to be retrieved. Only Ids that the caller has access to will be returned.
   * @maxItems 100
   * @minItems 0
   */
  driverId?: string[];
}

export interface GetDevicesParams {
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device locations to filter the results by. */
  locationId?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Include the Health status of the device. This requires `r:devices` permission. */
  includeHealth?: boolean;
  /** The device types to filter the results by. */
  type?: string[];
  /** The device categories to filter the results by. */
  category?: string[];
  /**
   * Treat all capability filter query params as a logical "or" or "and" with a default of "and".
   * @default "and"
   */
  capabilitiesMode?: 'or' | 'and';
  /**
   * Restricted devices are hidden by default. This query parameter will reveal them. Device status will
   * not be provided if the token does not have sufficient access level to view the device status even
   * if includeStatus parameter is set to true.
   */
  includeRestricted?: boolean;
  /** Only list devices accessible by the given accessLevel. */
  accessLevel?: number;
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /**
   * GROUP type devices are devices that represent Device Groups. In order to include these devices in the list,
   * a flag needs to be included.
   */
  includeGroups?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface UpdateHubDeviceParams {
  /**
   * A flag that is used to indicate that the driver and profile should be updated even if the fingerprinting process
   * fails. Additionally, forceUpdate is required when a new device integration profile key is provided in
   * the request payload.
   */
  forceUpdate?: boolean;
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
  /** The Device ID */
  deviceId: string;
}

export interface ListProductsParams {
  /** The onboardingProfileId to filter the products by. */
  onboardingProfileId?: string;
  /** The brandId to filter the products by. */
  brandId?: string;
}

export interface UploadProductImagePayload {
  /** Image to upload */
  image: File;
}

export interface ProgressReportParams {
  /** ID of the test session */
  test_session_id: string;
}

export interface UserSessionsParams {
  /** @default true */
  'get-ongoing'?: boolean;
  /** @default true */
  'get-finished'?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'http://pastora.st.internal';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Pastora API
 * @version v20210608
 * @baseUrl http://pastora.st.internal
 *
 * Partner Tools API
 */
export class PastoraApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  analytics = {
    /**
     * @description Get Product Analytics
     *
     * @tags analytics, pastora
     * @name GetProductAnalytics
     * @summary Get Product Analytics
     * @request GET:/analytics/products
     * @secure
     */
    getProductAnalytics: (query: GetProductAnalyticsParams, params: RequestParams = {}) =>
      this.request<PagedAnalyticsData, ErrorResponse>({
        path: `/analytics/products`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  brands = {
    /**
     * @description Creates a brand in the organization provided if the user is part of that organization
     *
     * @tags pastora, brands
     * @name CreateBrand
     * @summary Create a new private brand tied to your organization
     * @request POST:/brands
     * @secure
     */
    createBrand: (brandCreate: BrandCreate, params: RequestParams = {}) =>
      this.request<Brand, ErrorResponse>({
        path: `/brands`,
        method: 'POST',
        body: brandCreate,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the most recent version of all brands filtered organizationId.
     *
     * @tags pastora, brands
     * @name GetBrands
     * @summary Get the most recent version of all brands that the organization can see.
     * @request GET:/brands
     * @secure
     */
    getBrands: (params: RequestParams = {}) =>
      this.request<Brand[], ErrorResponse>({
        path: `/brands`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists brand versions by brandId
     *
     * @tags pastora, brands
     * @name GetBrandVersions
     * @summary List brand versions by brandId
     * @request GET:/brands/{brandId}
     * @secure
     */
    getBrandVersions: (brandId: string, params: RequestParams = {}) =>
      this.request<BrandVersionResponse[], ErrorResponse>({
        path: `/brands/${brandId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new version of a brand. Previous versions of the brand will remain unchanged by this operation. Only applies if the latest version is either published, canceled or rejected.
     *
     * @tags pastora, brands
     * @name VersionBrand
     * @summary Create a new version of a brand.
     * @request POST:/brands/{brandId}
     * @secure
     */
    versionBrand: (brandId: string, brandCreate: BrandCreate, params: RequestParams = {}) =>
      this.request<Brand, ErrorResponse>({
        path: `/brands/${brandId}`,
        method: 'POST',
        body: brandCreate,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description deletes a brand and all its versions
     *
     * @tags pastora, brands
     * @name DeleteBrand
     * @summary deletes a brand and all its versions
     * @request DELETE:/brands/{brandId}
     * @secure
     */
    deleteBrand: (brandId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/brands/${brandId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Gets a brand by `brandId` and `versionNumber`. Private brands are only returned if the user belongs to the same organization
     *
     * @tags pastora, brands
     * @name GetBrand
     * @summary Get a brand by brandId, versionNumber.
     * @request GET:/brands/{brandId}/{versionNumber}
     * @secure
     */
    getBrand: (brandId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<Brand, ErrorResponse>({
        path: `/brands/${brandId}/${versionNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a brand by `brandId` and `versionNumber`. Brand must be private and the user must belong to the same organization
     *
     * @tags pastora, brands
     * @name UpdateBrand
     * @summary Updates a private brand if the user belongs to the same organization
     * @request PUT:/brands/{brandId}/{versionNumber}
     * @secure
     */
    updateBrand: (brandId: string, versionNumber: number, brandUpdate: BrandUpdate, params: RequestParams = {}) =>
      this.request<Brand, ErrorResponse>({
        path: `/brands/${brandId}/${versionNumber}`,
        method: 'PUT',
        body: brandUpdate,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a brand by `brandId` and `versionNumber`. Brand must be private and the user must belong to the same organization
     *
     * @tags pastora, brands
     * @name DeleteBrandVersion
     * @summary Delete a private brand if the user belongs to the same organization
     * @request DELETE:/brands/{brandId}/{versionNumber}
     * @secure
     */
    deleteBrandVersion: (brandId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/brands/${brandId}/${versionNumber}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description submits a brand for review
     *
     * @tags pastora, brands
     * @name SubmitBrandForReview
     * @summary submit a brand for review
     * @request PUT:/brands/{brandId}/{versionNumber}/review
     * @secure
     */
    submitBrandForReview: (brandId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/brands/${brandId}/${versionNumber}/review`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description get brand review
     *
     * @tags pastora, brands
     * @name GetBrandReview
     * @summary gets Brand review
     * @request GET:/brands/{brandId}/{versionNumber}/review
     * @secure
     */
    getBrandReview: (brandId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<Review, ErrorResponse>({
        path: `/brands/${brandId}/${versionNumber}/review`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description cancel a brand review
     *
     * @tags pastora, brands
     * @name CancelBrandReview
     * @summary cancel a brand review
     * @request PUT:/brands/{brandId}/{versionNumber}/review/cancel
     * @secure
     */
    cancelBrandReview: (brandId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/brands/${brandId}/${versionNumber}/review/cancel`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description Upload an icon for a `brandId` and `versionNumber`. Due to swagger v2 limitation it shows as multipart upload but it is a binary upload. Only accepts image/png filetype
     *
     * @tags pastora, brands
     * @name UploadBrandIcon
     * @summary Upload an icon for a brand.
     * @request PUT:/brands/{brandId}/{versionNumber}/icon
     * @secure
     */
    uploadBrandIcon: (
      brandId: string,
      versionNumber: number,
      data: UploadBrandIconPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/brands/${brandId}/${versionNumber}/icon`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
  };
  deviceintegrationprofiles = {
    /**
     * @description GET all capabilities for latest minor version of a driver
     *
     * @tags deviceintegrationprofiles, pastora
     * @name GetDeviceIntegrationProfileLatest
     * @summary GET all capabilities for latest minor version of a driver
     * @request GET:/deviceintegrationprofiles/{deviceIntegrationProfileId}/{deviceIntegrationProfileVersion}/latest
     * @secure
     */
    getDeviceIntegrationProfileLatest: (
      deviceIntegrationProfileId: string,
      deviceIntegrationProfileVersion: string,
      params: RequestParams = {},
    ) =>
      this.request<BaseCapabilityReference[], ErrorResponse>({
        path: `/deviceintegrationprofiles/${deviceIntegrationProfileId}/${deviceIntegrationProfileVersion}/latest`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  drivers = {
    /**
     * @description Lists drivers owned by user
     *
     * @tags drivers, pastora
     * @name ListDrivers
     * @summary List Drivers
     * @request GET:/drivers
     * @secure
     */
    listDrivers: (query: ListDriversParams, params: RequestParams = {}) =>
      this.request<SimpleDriver[], ErrorResponse>({
        path: `/drivers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves a driver by identifier. Will return the latest version of driver
     *
     * @tags drivers, pastora
     * @name GetDriver
     * @summary Get Driver
     * @request GET:/drivers/{driverId}
     * @secure
     */
    getDriver: (driverId: string, params: RequestParams = {}) =>
      this.request<Driver, ErrorResponse>({
        path: `/drivers/${driverId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns driver records for all drivers in the current default channel. These drivers are the set that are automatically matched against during device join events and will be automatically installed
     *
     * @tags drivers, pastora
     * @name GetDefaultDrivers
     * @summary Get Current Default Drivers
     * @request GET:/drivers/default
     * @secure
     */
    getDefaultDrivers: (params: RequestParams = {}) =>
      this.request<Driver[], ErrorResponse>({
        path: `/drivers/default`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gets list of device integration profiles matched to their device profiles linked to the provided driver
     *
     * @tags drivers, pastora
     * @name ListDriverMatchedProfiles
     * @summary Get Device Integration Profiles matched to device profiles from Driver Id
     * @request GET:/drivers/deviceprofiles/{driverId}
     * @secure
     */
    listDriverMatchedProfiles: (driverId: string, params: RequestParams = {}) =>
      this.request<MatchedProfile[], ErrorResponse>({
        path: `/drivers/deviceprofiles/${driverId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devices = {
    /**
     * @description Get a list of devices.
     *
     * @tags Devices, pastora
     * @name GetDevices
     * @summary List devices.
     * @request GET:/devices
     * @secure
     */
    getDevices: (query: GetDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  hubdevices = {
    /**
     * @description Updates a hub device record (Widget Backed)
     *
     * @tags HubDevices, pastora
     * @name UpdateHubDevice
     * @summary Update Device Record For Hub Device
     * @request PATCH:/hubdevices/{hubDeviceId}/childdevice/{deviceId}
     * @secure
     */
    updateHubDevice: (
      { hubDeviceId, deviceId, ...query }: UpdateHubDeviceParams,
      updateHubDeviceRequest: EdgeDeviceUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/childdevice/${deviceId}`,
        method: 'PATCH',
        query: query,
        body: updateHubDeviceRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  invites = {
    /**
     * No description
     *
     * @tags invites, pastora
     * @name DeleteInvite
     * @summary Revoke an existing invitation
     * @request DELETE:/invites/{id}
     * @secure
     */
    deleteInvite: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/invites/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  onboardingprofiles = {
    /**
     * @description Get the most recent version of all onboarding profiles the user has access to
     *
     * @tags pastora, onboardingprofiles
     * @name GetLatestOnboardingProfiles
     * @summary Get the most recent version of all onboarding profiles the user has access to
     * @request GET:/onboardingprofiles
     * @secure
     */
    getLatestOnboardingProfiles: (params: RequestParams = {}) =>
      this.request<OnboardingProfile[], ErrorResponse>({
        path: `/onboardingprofiles`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description create an onboarding profile tied to your organization
     *
     * @tags pastora, onboardingprofiles
     * @name CreateOnboardingProfile
     * @summary create an onboarding profile tied to your organization
     * @request POST:/onboardingprofiles
     * @secure
     */
    createOnboardingProfile: (onboardingProfileCreate: OnboardingProfileCreate, params: RequestParams = {}) =>
      this.request<OnboardingProfile, ErrorResponse>({
        path: `/onboardingprofiles`,
        method: 'POST',
        body: onboardingProfileCreate,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List versions of an onboarding profile
     *
     * @tags pastora, onboardingprofiles
     * @name GetOnboardingProfileVersions
     * @summary List versions of an onboarding profile
     * @request GET:/onboardingprofiles/{onboardingProfileId}
     * @secure
     */
    getOnboardingProfileVersions: (onboardingProfileId: string, params: RequestParams = {}) =>
      this.request<OnboardingProfile[], ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new version of an onboarding profile. Previous versions of the onboarding profile will remain unchanged by this operation. Only applies if the latest version is either published, canceled or rejected.
     *
     * @tags pastora, onboardingprofiles
     * @name AddOnboardingProfileVersion
     * @summary Creates a new version of an onboarding profile
     * @request POST:/onboardingprofiles/{onboardingProfileId}
     * @secure
     */
    addOnboardingProfileVersion: (
      onboardingProfileId: string,
      onboardingProfileCreate: OnboardingProfileCreate,
      params: RequestParams = {},
    ) =>
      this.request<OnboardingProfile, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}`,
        method: 'POST',
        body: onboardingProfileCreate,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description deletes an onboarding profile and all its versions
     *
     * @tags pastora, onboardingprofiles
     * @name DeleteOnboardingProfile
     * @summary deletes an onboarding profile and all its versions
     * @request DELETE:/onboardingprofiles/{onboardingProfileId}
     * @secure
     */
    deleteOnboardingProfile: (onboardingProfileId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description gets an onboarding profile by `onboardingProfileId` and `versionNumber`.
     *
     * @tags pastora, onboardingprofiles
     * @name GetOnboardingProfileById
     * @summary gets an onboarding profile by onboardingProfileId, versionNumber.
     * @request GET:/onboardingprofiles/{onboardingProfileId}/{versionNumber}
     * @secure
     */
    getOnboardingProfileById: (onboardingProfileId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<OnboardingProfile, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}/${versionNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description updates an onboarding profile version
     *
     * @tags pastora, onboardingprofiles
     * @name UpdateOnboardingProfile
     * @summary updates an onboarding profile version
     * @request PUT:/onboardingprofiles/{onboardingProfileId}/{versionNumber}
     * @secure
     */
    updateOnboardingProfile: (
      onboardingProfileId: string,
      versionNumber: number,
      onboardingProfileUpdate: OnboardingProfileUpdate,
      params: RequestParams = {},
    ) =>
      this.request<OnboardingProfile, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}/${versionNumber}`,
        method: 'PUT',
        body: onboardingProfileUpdate,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description deletes an onboarding profile version
     *
     * @tags pastora, onboardingprofiles
     * @name DeleteOnboardingProfileVersion
     * @summary deletes an onboarding profile version
     * @request DELETE:/onboardingprofiles/{onboardingProfileId}/{versionNumber}
     * @secure
     */
    deleteOnboardingProfileVersion: (onboardingProfileId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}/${versionNumber}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description submits an onboardingprofile for review
     *
     * @tags pastora, onboardingprofiles
     * @name SubmitOnboardingprofileForReview
     * @summary submit an onboardingprofile for review
     * @request PUT:/onboardingprofiles/{onboardingProfileId}/{versionNumber}/review
     * @secure
     */
    submitOnboardingprofileForReview: (
      onboardingProfileId: string,
      versionNumber: number,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}/${versionNumber}/review`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description get onboarding profile review
     *
     * @tags pastora, onboardingprofiles
     * @name GetOnboardingProfileReview
     * @summary gets onboarding profile review
     * @request GET:/onboardingprofiles/{onboardingProfileId}/{versionNumber}/review
     * @secure
     */
    getOnboardingProfileReview: (onboardingProfileId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<Review, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}/${versionNumber}/review`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description cancel an onboarding profile review
     *
     * @tags pastora, onboardingprofiles
     * @name CancelOnboardingprofileReview
     * @summary cancel an onboarding profile review
     * @request PUT:/onboardingprofiles/{onboardingProfileId}/{versionNumber}/review/cancel
     * @secure
     */
    cancelOnboardingprofileReview: (onboardingProfileId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/onboardingprofiles/${onboardingProfileId}/${versionNumber}/review/cancel`,
        method: 'PUT',
        secure: true,
        ...params,
      }),
  };
  organizations = {
    /**
     * @description Create an organization
     *
     * @tags organizations, pastora
     * @name CreateOrganization
     * @summary Create developer organization
     * @request POST:/organizations
     * @secure
     */
    createOrganization: (request: OrganizationCreateRequest, params: RequestParams = {}) =>
      this.request<OrganizationResponse, ErrorResponse>({
        path: `/organizations`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a list of the organizations visible for a logged in user. Listing will also provision a "default user organization" for a user if they do not already have one created.
     *
     * @tags organizations, pastora
     * @name ListUserOrganizations
     * @summary List organizations
     * @request GET:/organizations
     * @secure
     */
    listUserOrganizations: (params: RequestParams = {}) =>
      this.request<OrganizationResponseList, ErrorResponse>({
        path: `/organizations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a single organization.
     *
     * @tags organizations, pastora
     * @name GetOrganizationByNameOrId
     * @summary Get an organization by name or ID.
     * @request GET:/organizations/{organizationNameOrId}
     * @secure
     */
    getOrganizationByNameOrId: (organizationNameOrId: string, params: RequestParams = {}) =>
      this.request<OrganizationResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a developer organization.
     *
     * @tags organizations, pastora
     * @name DeleteOrganizationByNameOrId
     * @summary Delete developer organization.
     * @request DELETE:/organizations/{organizationNameOrId}
     * @secure
     */
    deleteOrganizationByNameOrId: (organizationNameOrId: string, params: RequestParams = {}) =>
      this.request<DeleteResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an organization
     *
     * @tags organizations, pastora
     * @name UpdateOrganization
     * @summary Update developer organization
     * @request PUT:/organizations/{organizationNameOrId}
     * @secure
     */
    updateOrganization: (
      organizationNameOrId: string,
      request: OrganizationUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description get a list of the organization members
     *
     * @tags organizations, pastora
     * @name GetOrganizationMembers
     * @summary get a list of the organization members
     * @request GET:/organizations/{organizationNameOrId}/members
     * @secure
     */
    getOrganizationMembers: (organizationNameOrId: string, params: RequestParams = {}) =>
      this.request<PastoraOrganizationMember[], any>({
        path: `/organizations/${organizationNameOrId}/members`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Invite users to development organization by E-mail address or phone number.
     *
     * @tags organizations, pastora
     * @name InviteUsers
     * @summary Invite users to organization
     * @request POST:/organizations/{organizationNameOrId}/members/invite
     * @secure
     */
    inviteUsers: (organizationNameOrId: string, request: InviteRequest, params: RequestParams = {}) =>
      this.request<InviteResponse, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}/members/invite`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Endpoint for a user to accept an organization invite.
     *
     * @tags organizations, pastora
     * @name MemberAccept
     * @summary Accept organization invite
     * @request POST:/organizations/{organizationNameOrId}/members/accept
     * @secure
     */
    memberAccept: (organizationNameOrId: string, request: OrganizationMember, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}/members/accept`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description This endpoint is for org administrators to be able to remove or modify existing organization members.
     *
     * @tags organizations, pastora
     * @name ManageOrganizationUsers
     * @summary Manage organization members.
     * @request POST:/organizations/{organizationNameOrId}/members/manage
     * @secure
     */
    manageOrganizationUsers: (
      organizationNameOrId: string,
      request: ModifyMembersRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/organizations/${organizationNameOrId}/members/manage`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  products = {
    /**
     * @description returns latest version of every product the user has access to
     *
     * @tags pastora, products
     * @name ListProducts
     * @summary list products the user has access to
     * @request GET:/products
     * @secure
     */
    listProducts: (query: ListProductsParams, params: RequestParams = {}) =>
      this.request<ProductVersion[], ErrorResponse>({
        path: `/products`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description create a product with version 0
     *
     * @tags pastora, products
     * @name CreateProduct
     * @summary create a product with version 0
     * @request POST:/products
     * @secure
     */
    createProduct: (productCreate: ProductCreate, params: RequestParams = {}) =>
      this.request<ProductVersion, ErrorResponse>({
        path: `/products`,
        method: 'POST',
        body: productCreate,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description lists versions of a product
     *
     * @tags pastora, products
     * @name ListProductVersions
     * @summary lists versions of a product
     * @request GET:/products/{productId}
     * @secure
     */
    listProductVersions: (productId: string, params: RequestParams = {}) =>
      this.request<ProductVersion[], ErrorResponse>({
        path: `/products/${productId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new version of a product. Previous versions of the product will remain unchanged by this operation. Only applies if the latest version is either published, canceled or rejected.
     *
     * @tags pastora, products
     * @name VersionProduct
     * @summary Creates a new version of a product
     * @request POST:/products/{productId}
     * @secure
     */
    versionProduct: (productId: string, productVersionUpdate: ProductVersionUpdate, params: RequestParams = {}) =>
      this.request<ProductVersion, ErrorResponse>({
        path: `/products/${productId}`,
        method: 'POST',
        body: productVersionUpdate,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description delete a product
     *
     * @tags pastora, products
     * @name DeleteProduct
     * @summary delete a product
     * @request DELETE:/products/{productId}
     * @secure
     */
    deleteProduct: (productId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/products/${productId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description get a product version
     *
     * @tags pastora, products
     * @name GetProductVersion
     * @summary get a product version
     * @request GET:/products/{productId}/{versionNumber}
     * @secure
     */
    getProductVersion: (productId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<ProductVersion, ErrorResponse>({
        path: `/products/${productId}/${versionNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description update a product version
     *
     * @tags pastora, products
     * @name PartiallyUpdateProductVersion
     * @summary update fields of the product versions that are in the body
     * @request PUT:/products/{productId}/{versionNumber}
     * @secure
     */
    partiallyUpdateProductVersion: (
      productId: string,
      versionNumber: number,
      productVersionUpdate: ProductVersionUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ProductVersion, ErrorResponse>({
        path: `/products/${productId}/${versionNumber}`,
        method: 'PUT',
        body: productVersionUpdate,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description delete a product version
     *
     * @tags pastora, products
     * @name DeleteProductVersion
     * @summary delete a product version
     * @request DELETE:/products/{productId}/{versionNumber}
     * @secure
     */
    deleteProductVersion: (productId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/products/${productId}/${versionNumber}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description submits a product for review
     *
     * @tags pastora, products
     * @name SubmitProductForReview
     * @summary submit a product for review
     * @request PUT:/products/{productId}/{versionNumber}/review
     * @secure
     */
    submitProductForReview: (productId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/products/${productId}/${versionNumber}/review`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description get product review
     *
     * @tags pastora, products
     * @name GetProductReview
     * @summary gets product review
     * @request GET:/products/{productId}/{versionNumber}/review
     * @secure
     */
    getProductReview: (productId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<Review, ErrorResponse>({
        path: `/products/${productId}/${versionNumber}/review`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description cancel a product review
     *
     * @tags pastora, products
     * @name CancelProductReview
     * @summary cancel a product review
     * @request PUT:/products/{productId}/{versionNumber}/review/cancel
     * @secure
     */
    cancelProductReview: (productId: string, versionNumber: number, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/products/${productId}/${versionNumber}/review/cancel`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description Upload an image for a `productId` and `versionNumber`. Due to swagger v2 limitation it shows as multipart upload but it is a binary upload. Only accepts image/png filetype
     *
     * @tags pastora, products
     * @name UploadProductImage
     * @summary Upload an image for a product.
     * @request PUT:/products/{productId}/{versionNumber}/image
     * @secure
     */
    uploadProductImage: (
      productId: string,
      versionNumber: number,
      data: UploadProductImagePayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/products/${productId}/${versionNumber}/image`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
  };
  reviews = {
    /**
     * @description get list of entities that have been submitted for review
     *
     * @tags reviews, pastora
     * @name GetReviews
     * @summary get list of entities that have been submitted for review
     * @request GET:/reviews
     * @secure
     */
    getReviews: (params: RequestParams = {}) =>
      this.request<Review[], ErrorResponse>({
        path: `/reviews`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description get a review object
     *
     * @tags reviews, pastora
     * @name GetReview
     * @summary get a review
     * @request GET:/reviews/{reviewId}
     * @secure
     */
    getReview: (reviewId: string, params: RequestParams = {}) =>
      this.request<Review, ErrorResponse>({
        path: `/reviews/${reviewId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description cancel a review
     *
     * @tags reviews, pastora
     * @name CancelReview
     * @summary cancel a review
     * @request PUT:/reviews/{reviewId}/cancel
     * @secure
     */
    cancelReview: (reviewId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/reviews/${reviewId}/cancel`,
        method: 'PUT',
        secure: true,
        ...params,
      }),
  };
  productcategories = {
    /**
     * @description get list of product categories
     *
     * @tags pastora, productcategories
     * @name GetProductCategories
     * @summary get list of product categories
     * @request GET:/productcategories
     * @secure
     */
    getProductCategories: (params: RequestParams = {}) =>
      this.request<ProductCategory[], any>({
        path: `/productcategories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  terms = {
    /**
     * @description get terms of service together with whether they've been accepted or not for latest version
     *
     * @tags terms, pastora
     * @name GetTerms
     * @summary get terms of service together with whether they've been accepted or not for latest version
     * @request GET:/terms
     * @secure
     */
    getTerms: (params: RequestParams = {}) =>
      this.request<TosData[], ErrorResponse>({
        path: `/terms`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description deletes terms of service acceptance. Works only in lower environments
     *
     * @tags terms, pastora
     * @name DeleteTerms
     * @summary deletes terms of service info
     * @request DELETE:/terms
     * @secure
     */
    deleteTerms: (params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/terms`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description accept the terms of service
     *
     * @tags terms, pastora
     * @name AcceptTerms
     * @summary accept the terms of service
     * @request PUT:/terms/{tosname}/{tosversion}
     * @secure
     */
    acceptTerms: (tosname: string, tosversion: number, params: RequestParams = {}) =>
      this.request<TosData, ErrorResponse>({
        path: `/terms/${tosname}/${tosversion}`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  testsuite = {
    /**
     * @description Creates a new test sessions, for preview
     *
     * @tags test-session, pastora
     * @name InitTest
     * @summary Create a new test session
     * @request POST:/testsuite/test-session/init-test
     * @secure
     */
    initTest: (initTest: InitTest, params: RequestParams = {}) =>
      this.request<TestSessionCreated, ErrorResponse>({
        path: `/testsuite/test-session/init-test`,
        method: 'POST',
        body: initTest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Starts a new test execution
     *
     * @tags test-session, pastora
     * @name PostTest
     * @summary Starts execution of test session
     * @request POST:/testsuite/test-session/start-test
     * @secure
     */
    postTest: (startTest: StartTest, params: RequestParams = {}) =>
      this.request<TestSessionResponse, ErrorResponse>({
        path: `/testsuite/test-session/start-test`,
        method: 'POST',
        body: startTest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Marks test session for cancellation. This is not immediate, executor will cancel at its own leisure
     *
     * @tags test-session, pastora
     * @name RequestCancel
     * @summary Schedules test for cancelation
     * @request POST:/testsuite/test-session/request-cancel
     * @secure
     */
    requestCancel: (session: Session, params: RequestParams = {}) =>
      this.request<TestSessionResponse, ErrorResponse>({
        path: `/testsuite/test-session/request-cancel`,
        method: 'POST',
        body: session,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns detailed report for specified test session
     *
     * @tags test-session, pastora
     * @name ProgressReport
     * @summary Get report for Test Session
     * @request GET:/testsuite/test-session/progress-report
     * @secure
     */
    progressReport: (query: ProgressReportParams, params: RequestParams = {}) =>
      this.request<TestSessionReport, ErrorResponse>({
        path: `/testsuite/test-session/progress-report`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns list of all devices under this user, for which Test Suite can run tests
     *
     * @tags user, pastora
     * @name UserDevices
     * @summary Get devices for this user, for which he can run tests (subset of all devices)
     * @request GET:/testsuite/user-devices
     * @secure
     */
    userDevices: (params: RequestParams = {}) =>
      this.request<DeviceList, ErrorResponse>({
        path: `/testsuite/user-devices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns list of all test sessions for this user
     *
     * @tags user, pastora
     * @name UserSessions
     * @summary List all user sessions
     * @request GET:/testsuite/user-sessions
     * @secure
     */
    userSessions: (query: UserSessionsParams, params: RequestParams = {}) =>
      this.request<SessionList, ErrorResponse>({
        path: `/testsuite/user-sessions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
